export const work = {
  offlineMove: {
    saved: "Gespeichert, wird gesendet, sobald Sie online sind.",
  },
  whoWhen: {
    who: "Wer",
    when: "Wann",
    whenPlaceholder: "Tag wählen",
    change: "Ändern",
    applyToAll: "Auf alle anwenden",
    done: "Fertig",
    pickContractorTitle: "Auftragnehmer wählen",
    pickContractorsTitle: "Auftragnehmer für Angebote wählen",
    summary: {
      person: "{{name}} erledigt es",
      teamQueue: "Ihr Team, noch niemand gewählt",
      contractor: "{{name}} erledigt es",
      pickContractor: "Auftragnehmer wählen",
      pickContractors: "Auftragnehmer für Angebote wählen",
      quotes_one: "{{count}} Auftragnehmer um ein Angebot bitten",
      quotes_other: "{{count}} Auftragnehmer um Angebote bitten",
    },
    sheetTitle: "Arbeit anlegen",
    title: "Titel",
    brief: "Beschreibung",
    moreDetails: "Mehr Details",
    create: "Anlegen",
    created: "Arbeit angelegt und übergeben",
    quotesSent_one: "Arbeit angelegt. Angebotsanfrage an {{count}} Auftragnehmer gesendet",
    quotesSent_other: "Arbeit angelegt. Angebotsanfragen an {{count}} Auftragnehmer gesendet",
    notToldTitle: "Zugewiesen, aber nicht benachrichtigt",
    notToldBody: "{{name}} hat die Arbeit, aber keine E-Mail-Adresse und kein Konto, daher wurde niemand benachrichtigt. Sagen Sie selbst Bescheid.",
    failedTitle: "Arbeit konnte nicht angelegt werden",
    failedBody: "Bitte versuchen Sie es erneut.",
  },
  scope: { contractorWork: "Auftragsarbeit" },
  reportsTab: { all: "Alle Berichte", versionsTitle: "{{kind}}: Versionen", openReport: "{{kind}} öffnen", noVersions: "Noch keine gespeicherten Versionen.", more: "{{n}} weitere in {{kind}}", withSubJobs: "Aufträge mit Teilaufträgen" },
queueRow: {
secondaryDefault: "Starten",
you: "Sie",
raisedBy: "Gemeldet von {{name}}",
planned: "Geplant {{when}}",
unassigned: "Nicht zugewiesen",
showFewerStatusLabels: "Weniger Statusbezeichnungen anzeigen",
showMoreStatusLabels_one: "{{count}} weitere Statusbezeichnung anzeigen: {{labels}}",
showMoreStatusLabels_other: "{{count}} weitere Statusbezeichnungen anzeigen: {{labels}}",
moreActionsForA11y: "Weitere Aktionen für {{title}}",
secondaryActionA11y: "{{action}} {{title}}",
openItemA11y: "Öffnen Sie {{title}}",
open: "Öffnen",
},
jobChecks: {
  inline: {
    hide: "Antworten ausblenden",
    loading: "Antworten werden geladen…",
    loadFailed: "Die Antworten konnten nicht geladen werden. Öffnen Sie den Auftrag erneut.",
    failed: "Nicht bestanden",
    skipped: "Übersprungen",
    photos_one: "{{count}} Foto",
    photos_other: "{{count}} Fotos",
  },
stageLabel: {
pre: "Vorprüfung",
post: "Nachprüfung",
standalone: "Prüfung",
},
stageLabelLower: {
pre: "Vorprüfung",
post: "Nachprüfung",
standalone: "Prüfung",
},
round: "Runde {{n}}",
noneYet: "Noch keine",
removeStageA11y: "{{stage}} entfernen",
attachFailedTitle: "Auftrag erstellt, aber die {{stage}} konnte nicht angehängt werden",
attachFailedBody: "Fügen Sie sie im Auftrag hinzu.",
attach: {
addAs: "Als {{stage}} hinzufügen",
chooseChecklist: "Checkliste auswählen",
attachTemplateAsA11y: "{{name}} als {{stage}} anhängen",
chooseFirstA11y: "Wählen Sie zuerst eine Checkliste",
attachAsA11y: "Als {{stage}} anhängen",
loadingTitle: "Ihre Checklisten werden geladen…",
loadingBody: "Einen Moment – die Bibliothek wird abgerufen.",
noMatchTitle: "Keine passenden Checklisten",
noMatchBody: "Versuchen Sie eine kürzere Suche oder leeren Sie sie, um alles zu sehen.",
emptyTitle: "Noch keine Checklisten zum Anhängen",
emptyBody: "Jede Checkliste kann als Prüfung dienen. Erstellen Sie eine, dann erscheint sie hier.",
},
resultLabel: {
pass: "Bestanden",
flag: "Markiert",
fail: "Nicht bestanden",
},
stepCount_one: "{{completed}}/{{count}} Schritt",
stepCount_other: "{{completed}}/{{count}} Schritte",
gateReasonSingle: "Die {{stage}} „{{name}}“ muss abgeschlossen werden, {{verb}}.",
gateReasonMultiple: "{{count}} {{noun}} müssen abgeschlossen werden, {{verb}}.",
checksNoun: "Prüfungen",
beforeSubmitted: "bevor dieser Arbeitsauftrag eingereicht wird",
beforeStarted: "bevor dieser Arbeitsauftrag beginnt",
gateDefaultReason: "Zuerst muss eine Prüfung durchgeführt werden.",
templateStepCount_one: "{{count}} Schritt",
templateStepCount_other: "{{count}} Schritte",
historyOneFailure: "1 Fehler über {{span}}.",
historyFailures_one: "{{count}} Fehler über {{span}}.",
historyFailures_other: "{{count}} Fehler über {{span}}.",
historyOneFlag: "1 markiertes Element über {{span}}.",
historyFlags_one: "{{count}} markiertes Element über {{span}}.",
historyFlags_other: "{{count}} markierte Elemente über {{span}}.",
historyNoFailures: "Keine Fehler über {{span}}.",
spanLastCheck: "die letzte Prüfung",
spanLastChecks_one: "die letzte Prüfung",
spanLastChecks_other: "die letzten {{count}} Prüfungen",
completedStatus: "{{progress}} abgeschlossen",
notFinishedStatus: "{{progress}} – noch nicht fertig",
reworkRequested: "Nachbesserung angefordert",
section: {
heading: "Was dieser Auftrag braucht",
addCheckA11y: "Prüfung zu diesem Arbeitsauftrag hinzufügen",
addCheck: "Prüfung hinzufügen",
tryAgainA11y: "Prüfungen erneut laden",
tryAgain: "Erneut versuchen",
noChecksTitle: "Keine Prüfungen für diesen Arbeitsauftrag",
headingPlan: "Was jeder Auftrag braucht",
noChecksTitlePlan: "Noch keine Prüfungen",
noChecksBody: "Hängen Sie eine Checkliste an, die vor Beginn oder nach Abschluss der Arbeiten ausgeführt wird, und die Antworten werden zum Nachweis dafür, dass dieser Arbeitsauftrag ausgeführt wurde.",
required: "Erforderlich",
round: "Durchgang {{number}}",
stop: "Halt {{number}}: {{name}}",
checkFallback: "Prüfung",
openCheckA11y: "{{verb}} {{stage}} {{name}}. {{progress}}.",
review: "Überprüfen",
continueVerb: "Weiter",
start: "Starten",
reviewCheck: "Prüfung überprüfen",
continueCheck: "Prüfung fortsetzen",
startCheck: "Prüfung starten",
removeCheckA11y: "Entfernen Sie {{stage}} {{name}}",
remove: "Entfernen",
},
},
requestActivityStream: {
  tidyFailedBody: "Gleich erneut versuchen oder so senden.",
  tidyFailedTitle: "Nachricht konnte nicht überarbeitet werden",
  tidiedReview: "Prüfen Sie sie vor dem Senden.",
  tidiedTitle: "Überarbeitete Nachricht",
  tidyUp: "Mit KI überarbeiten",
  stop: "Stopp",
  noAccountHint: "{{name}} hat kein Konto und sieht die Nachrichten hier nicht. Nutzen Sie Frage stellen, um per E-Mail zu schreiben.",
  notSent: "Nicht gesendet. Prüfen Sie die Verbindung und tippen Sie erneut auf Senden.",
theRequesterDefault: "Der Anforderer",
theTeamDefault: "Das Team",
raisedThis: "{{who}} hat dies erstellt · {{time}}",
you: "Sie",
noMessagesYetOperator: "Noch keine Nachrichten – antworten Sie unten, um die Konversation zu beginnen.",
noMessagesYetRequester: "Noch keine Nachrichten – senden Sie unten eine und das Team wird hier antworten.",
removePhotoA11y: "Foto entfernen",
replyOrLogNoteA11y: "Der anfragenden Person schreiben",
messageTeamA11y: "Nachricht an das Team",
replyOrLogNotePlaceholder: "Nachricht an die anfragende Person (sie sieht sie)…",
messageTeamPlaceholder: "Nachricht an das Team…",
sending: "Wird gesendet…",
send: "Senden",
sendReplyA11y: "Antwort senden",
signInRequiredTitle: "Anmeldung erforderlich",
signInToAttachPhotos: "Melden Sie sich an, um Fotos anzuhängen.",
uploadFailedTitle: "Upload fehlgeschlagen",
couldNotAttachPhoto: "Das Foto konnte nicht angehängt werden.",
},
requestDetailHeader: {
noPriority: "Keine Priorität",
assetNotSet: "Anlage nicht festgelegt",
notSet: "Nicht gesetzt",
tileLabel: {
asset: "Anlage",
requester: "Antragsteller",
priority: "Priorität",
scheduled: "Geplant",
respondBy: "Antworten bis",
},
openTileA11y: "Öffnen Sie {{label}}: {{value}}",
escalated: "Eskaliert · 48 Stunden+",
nextPrefix: "Als Nächstes: ",
},
repairDecisionPanel: {
yourDecisions: "Ihre Entscheidungen",
progress: "{{decided}} von {{total}} entschieden",
approveRecommendationTitle: "Mit allen Punkten einverstanden?",
approveRecommendationHint: "Markiert alle Punkte als genehmigt. Sie können vor dem Unterschreiben noch einzelne ablehnen.",
applying: "Wird angewendet...",
approveRecommended: "Alle genehmigen",
urgent: "Dringend",
highPriority: "Hohe Priorität",
noEvidence: "Keine Nachweise",
possibleDuplicate: "Mögliches Duplikat",
approved: "Genehmigt",
declined: "Abgelehnt",
awaitingDecision: "Warten auf Entscheidung",
approve: "Genehmigen",
decline: "Ablehnen",
approveItemA11y: "{{label}} genehmigen",
declineItemA11y: "Ablehnen {{label}}",
seeEvidenceA11y: "Siehe die Nachweise für {{label}}",
openAllEvidenceA11y: "Alle Nachweise für {{label}} öffnen",
evidenceThumbA11y: "{{label}} Nachweis {{number}}",
declineNoteA11y: "Ablehnungshinweis für {{label}}",
declineNotePlaceholder: "Warum lehnen Sie ab? (optional – mit dem Team geteilt)",
photoCount_one: "{{count}} Foto",
photoCount_other: "{{count}} Fotos",
videoCountClause_one: " · {{count}} Video",
videoCountClause_other: " · {{count}} Videos",
viewDetailsClause: " · Details anzeigen",
approvedTotal: "Genehmigter Gesamtbetrag: {{amount}}",
nothingApprovedYet: "Noch nichts genehmigt",
},
workIntelligenceActions: {
analyzeEvidence: "Fotos auslesen",
useComment: "Kommentar verwenden",
draftComment: "Kommentar entwerfen",
suggestAction: "Aktion vorschlagen",
useSuggestion: "Vorschlag übernehmen",
createJobFromSuggestion: "Arbeitsauftrag aus Vorschlag erstellen",
createJob: "Auftrag erstellen",
assessEvidence: "Nachweise bewerten",
useNote: "Hinweis verwenden",
couldNotCompleteRequest: "Die Anfrage konnte nicht abgeschlossen werden.",
unexpectedError: "Unerwarteter Fehler",
aiSuggestionWithConfidence: "KI-Vorschlag · {{percent}} % zuversichtlich",
aiSuggestion: "KI-Vorschlag",
priorityLabel: "Priorität: {{priority}}",
riskLabel: "Risiko: {{band}} ({{score}}/100)",
dismissSuggestionA11y: "Vorschlag verwerfen",
dismiss: "Schließen",
},
reportAccessRequests: {
roleLabel: {
owner: "Inhaber",
tenant: "Mieter/Nutzer",
landlord: "Vermieter",
manager: "Hausverwaltung",
client: "Kunde",
contractor: "Auftragnehmer",
other: "Sonstiges",
},
headerCount_one: "Zugriffsanfrage für Bericht · {{count}}",
headerCount_other: "Zugriffsanfragen für Berichte · {{count}}",
someoneFallback: "Jemand",
assetFallback: "Anlage",
approve: "Genehmigen",
decline: "Ablehnen",
couldNotCompleteTitle: "Konnte nicht abgeschlossen werden",
tryAgainMoment: "Bitte versuchen Sie es gleich noch einmal.",
alreadyDecidedTitle: "Bereits entschieden",
alreadyDecidedMessage: "Jemand anderes hat diese Anfrage bereits beantwortet.",
notPermittedTitle: "Nicht zulässig",
notPermittedMessage: "Sie haben keine Berechtigung, über diese Anfrage zu entscheiden.",
accessApproved: "Berichtszugriff genehmigt",
requestDeclined: "Anfrage abgelehnt",
},
assetRequestDetailScreen: {
actions: {
openJob: "Auftrag öffnen",
openInspection: "Prüfung öffnen",
approve: "Genehmigen",
replyFirstTitle: "Als beantwortet markieren und fortfahren?",
replyFirstBody: "Dieser Fall wartet auf den Kunden. Beim Fortfahren wird seine Antwort vermerkt und es geht weiter.",
replyFirstCancel: "Nicht jetzt",
replyFirstConfirm: "Als beantwortet markieren",
decline: "Ablehnen",
replied: "Antwort festhalten",
ask: "Frage stellen",
inspect: "Prüfen",
createWork: "Auftrag erstellen",
close: "Anfrage schließen",
},
assistant: {
title: "Assistent",
turnIntoWork: "In Arbeit umwandeln",
suggestNextSteps: "Nächste Schritte vorschlagen",
requestAssistantTitle: "Anfrage-Assistent",
promptWithTitle: "Helfen Sie mir, diese Anfrage („{{title}}“) zu prüfen und zu entscheiden, ob ich eine Frage stellen, eine Inspektion durchführen, Arbeit erstellen oder sie schließen soll.",
promptDefault: "Helfen Sie mir, diese Anfrage zu prüfen und zu entscheiden, ob ich eine Frage stellen, eine Inspektion durchführen, Arbeit erstellen oder sie schließen soll.",
},
capture: {
notSavedTitle: "Aufnahme nicht gespeichert",
notFoundMessage: "Diese Aufnahme konnte nicht gefunden werden. Bitte nehmen Sie sie erneut auf.",
mismatchMessage: "Diese Erfassung stimmt nicht mit der aktuellen Anfrage überein.",
notSupportedTitle: "Aufnahme nicht unterstützt",
scanNotSupportedMessage: "QR-Scan wird vom Scanner durchgeführt und nicht in Anfragen gespeichert.",
tryAgain: "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
noPhotoCaptured: "Es wurde kein Foto aufgenommen.",
signInToAttachPhotos: "Melden Sie sich an, um Fotos anzuhängen.",
couldNotUploadPhoto: "Das Foto konnte nicht hochgeladen werden.",
noCommentTextCaptured: "Es wurde kein Kommentartext erfasst.",
modeNotSupported: "Dieser Erfassungsmodus wird für Anfragen nicht unterstützt.",
photoAdded: "Foto zur Anfrage hinzugefügt",
commentAdded: "Anfragekommentar hinzugefügt",
measurementAdded: "Messung zu den Anfragekommentaren hinzugefügt",
measurementCommentTemplate: "Messung: {{reading}}",
},
toast: {
approved: "Anfrage genehmigt und die anfragende Person benachrichtigt. Tippen Sie jetzt auf Auftrag erstellen oder Prüfen, um sie zu planen.",
declined: "Anfrage abgelehnt. Die anfragende Person wurde benachrichtigt.",
caseClosed: "Anfrage geschlossen. Die anfragende Person wurde benachrichtigt.",
replyRecorded: "Antwort vermerkt. Die Anfrage liegt wieder bei Ihnen.",
messageSent: "Frage gesendet. Die Anfrage wartet auf die Antwort; Sie werden benachrichtigt.",
caseReopened: "Anfrage wieder geöffnet. Sie steht wieder unter Arbeit in „Braucht Sie“.",
},
screenTitle: "Anfrage",
loadingMessage: "Anfrage wird geladen...",
notFoundMessage: "Anfrage nicht gefunden",
notFoundHint: "Diese Anfrage wurde möglicherweise entfernt oder Sie haben möglicherweise keinen Zugriff.",
requestFallbackTitle: "Anfrage",
reopenFailedTitle: "Anfrage konnte nicht wieder geöffnet werden",
},
requestCaseLinkedWork: {
statusLabel: {
scheduled: "Geplant",
toSchedule: "Zur Planung",
due: "Fällig",
overdue: "Überfällig",
inProgress: "In Bearbeitung",
paused: "Pausiert",
submitted: "Eingereicht",
completedAwaitingSignoff: "Abgeschlossen – wartet auf Abnahme",
done: "Fertig",
reworkInProgress: "Überarbeitung in Bearbeitung",
cancelled: "Abgebrochen",
pending: "Ausstehend",
},
reportStatus: {
sharedReadyForReview: "Geteilt – bereit zur Überprüfung",
approved: "Genehmigt",
changesRequested: "Änderungen angefordert",
reviewed: "Bewertet",
},
provenance: {
youApproved: "Sie haben diese Arbeit genehmigt",
approvedByRequester: "Vom Antragsteller genehmigt",
youDeclined: "Sie haben dies abgelehnt – sprechen Sie es im Gespräch an",
declinedByRequester: "Vom Antragsteller abgelehnt",
followUpProposed: "Vom Team vorgeschlagenes Follow-up",
followUpJob: "Folgearbeitsauftrag",
addedByTeamNotFromReview: "Vom Team hinzugefügt – nicht aus Ihrer Prüfung",
addedByTeam: "Vom Team hinzugefügt",
},
repair: {
fallbackLabel: "Reparatur {{number}}",
approved: "Genehmigt",
declined: "Abgelehnt",
awaitingDecision: "Warten auf Entscheidung",
jobState: "Arbeitsauftrag: {{status}}",
noJobYet: "Noch kein Arbeitsauftrag",
},
heading: "Verknüpfte Arbeit",
inspectionTitle: "Inspektion",
completed: "Abgeschlossen",
jobFallbackTitle: "Auftrag",
reportTitle: "Inspektionsbericht",
youAcceptedAwaitingTeam: "Sie haben zugestimmt – warten auf die Bestätigung des Teams",
acceptedByRequesterVerify: "Vom Anforderer akzeptiert – zum Schließen bestätigen",
visitConfirmed: "Besuch bestätigt",
visitConfirmedByRequester: "Besuch vom Antragsteller bestätigt",
confirmVisitBelow: "Bestätigen Sie den Besuch unten",
awaitingRequesterVisitConfirmation: "Warten auf Bestätigung des Besuchs durch den Anfragenden",
photoCount_one: "{{count}} Foto",
photoCount_other: "{{count}} Fotos",
approvedRepairsAwaitingJobs_one: "{{count}} genehmigte Reparatur wartet auf Arbeitsaufträge",
approvedRepairsAwaitingJobs_other: "{{count}} genehmigte Reparaturen warten auf Arbeitsaufträge",
createApprovedJobs_one: "{{count}} genehmigten Arbeitsauftrag erstellen",
createApprovedJobs_other: "{{count}} genehmigte Arbeitsaufträge erstellen",
confirmVisit: "Besuch bestätigen",
confirmVisitA11y: "Bestätigen Sie, dass jemand bei dem Besuch anwesend sein kann",
requestDifferentTime: "Andere Zeit anfordern",
requestDifferentTimeA11y: "Bitten Sie um eine andere Besuchszeit",
reviewCompletionReport: "Abschlussbericht prüfen",
reviewAndSignOff: "Prüfen und abzeichnen",
viewCompletionReport: "Abschlussbericht anzeigen",
openCompletionReportA11y: "Öffnen Sie den Arbeitsauftragsabschlussbericht",
acceptCompletion: "Arbeit annehmen",
acceptCompletionA11y: "Akzeptieren Sie die abgeschlossene Arbeit",
requestRework: "Zurückschicken",
requestReworkA11y: "Auftrag zur Nachbesserung zurückschicken",
createJobsFromRepairsA11y: "Erstellen Sie Arbeitsaufträge aus den genehmigten Reparaturen",
viewReportResponse: "Berichtsantwort anzeigen",
reviewSharedReport: "Geteilten Bericht prüfen",
viewYourReportResponseA11y: "Sehen Sie sich Ihre Berichtsantwort an",
reviewSharedReportA11y: "Überprüfen Sie den freigegebenen Bericht",
},
detailRoute: {
notFoundTitle: "Arbeitsdetail",
notFoundMessage: "Arbeitselement nicht gefunden",
notFoundHint: "Öffnen Sie diesen Arbeitsauftrag oder diese Inspektion über „Arbeit“, „Anlagen“ oder einen gültigen freigegebenen Link.",
},
kanbanSwimlanes: {
emptyDefault: "Keine Elemente in dieser Ansicht.",
unassigned: "Nicht zugewiesen",
assetColumnHeader: "Anlage",
},
queueCardGrid: {
emptyDefault: "Keine Elemente in der Warteschlange",
open: "Öffnen",
start: "Starten",
openItemA11y: "Öffnen Sie {{title}}",
startItemA11y: "Starten Sie {{title}}",
},
statusTransitionBar: {
currentA11y: "Status: {{label}}",
moveToA11y: "Zu {{label}} wechseln",
changeStatusA11y: 'Status: {{label}}. Status ändern',
sheetTitle: 'Status ändern',
},
stall: {
days_one: "{{count}} Tag",
days_other: "{{count}} Tagen",
waitingOnYourApproval: "Wartet seit {{span}} auf Ihre Freigabe.",
waitingOnYourValidation: "Wartet seit {{span}} auf Ihre Validierung.",
noResponseFrom: "Keine Antwort von {{name}} seit {{span}}.",
notValidated: "{{name}} hat dies seit {{span}} nicht validiert.",
notApproved: "{{name}} hat dies seit {{span}} nicht freigegeben.",
theRecipient: "der empfangenden Person",
theRequester: "der anfragenden Person",
theApprover: "Die freigebende Person",
theValidator: "Die validierende Person",
approveOnTheirBehalf: "Stellvertretend freigeben",
validateInTheirPlace: "An deren Stelle validieren",
hintDecide: "Als Anlagenteam können Sie für sie entscheiden. Beides wird als stellvertretend erledigt vermerkt.",
hintValidate: "Als Anlagenteam können Sie dies an deren Stelle validieren.",
hintSignOff: "Als Anlagenteam können Sie dies an deren Stelle freigeben.",
saving: "Wird gespeichert…",
},
triageInbox: {
titleDefault: "Neu",
emptyLabelDefault: "Keine neuen Anfragen.",
cleared: "Alle Anfragen entschieden",
approve: "Genehmigen",
reject: "Ablehnen",
},
nameTypeFilter: {
typeDefault: "Typ",
pickerTitleDefault: "Nach Typ filtern",
any: "beliebig",
typeA11y: "{{label}}: {{value}}",
},
sortMenu: {
triggerA11y: "Sortieren: {{label}}",
sortBy: "Sortieren nach",
},
viewToggle: {
cards: "Karten",
table: "Tabelle",
kanban: "Kanban",
calendar: "Kalender",
},
attentionReasons: {
OVERDUE: "Überfällig",
AWAITING_YOU: "Wartet auf Sie",
AWAITING_OTHER: "Wartet auf jemand anderen",
UNSCHEDULED: "Noch nicht geplant",
DUE_SOON: "Bald fällig",
URGENT_PRIORITY: "Als dringend markiert",
APPROVAL_REQUIRED: "Wartet auf Ihre Genehmigung",
REVIEW_REQUIRED: "Wartet auf Ihre Prüfung",
REPAIR_JOBS_REQUIRED: "Genehmigte Reparaturen benötigen Aufträge",
STALLED: "Keine Rückmeldung — Sie können eingreifen",
},
list: {
  board: {
    moveItemA11y: "{{title}} verschieben",
    moveSelectedA11y: "{{n}} nach {{column}} verschieben",
    bulkSummaryBlocked: "{{n}} nach {{column}} verschieben. {{blocked}} können von ihrem Status aus nicht verschoben werden.",
    bulkSummary: "{{n}} nach {{column}} verschieben.",
    requestMoveReason: "Anfragen kommen durch Genehmigen, Ablehnen oder Umwandeln voran – öffnen Sie sie, um zu entscheiden.",
    inspectionMoveReason: "Inspektionen kommen voran, indem man sie durchführt – öffnen Sie sie, um fortzufahren.",
    moveNotAllowedTitle: "Verschieben nicht möglich",
    moveNotAllowed: "Diese Verschiebung ist nicht erlaubt.",
    cannotMoveStraight: "Arbeit mit Status „{{from}}“ kann nicht direkt zu „{{to}}“ wechseln.",
  },
  selectedA11y: "Ausgewählt",
  emptyState: {
    showMeHow: "Zeig mir, wie",
    scheduleInspection: "Inspektion planen",
    none: "Hier gibt es noch keine Arbeit. Planen Sie eine Inspektion, um zu beginnen.",
    showAll: "Alle Arbeit anzeigen",
    review: "Nichts wartet auf eine Prüfung.",
    due_soon: "Bald ist nichts fällig.",
    mine: "Ihnen ist im Moment nichts zugewiesen.",
    needs_attention: "Im Moment braucht Sie nichts.",
    clearFilters: "Filter zurücksetzen",
    filtered: "Nichts passt zu Ihrer Auswahl unter Filtern.",
  },
simpleStatus: {
  todo: "Zu erledigen",
  in_progress: "In Arbeit",
  waiting: "Wartet",
  done: "Erledigt",
  waitingFor: "Wartet auf {{name}}",
  waitingOn: "Wartet · {{who}}",
  waitingForAssignee: "Wartet auf die zugewiesene Person",
  waitingForRequester: "Wartet auf den Anfragenden",
  waitingForReview: "Wartet auf Prüfung",
  waitingForQuotes: "Wartet auf Angebote",
  waitingForApproval: "Wartet auf Freigabe",
},
quickView: {
needs_attention: "Braucht Sie",
mine: "Meine",
due_soon: "Bald fällig",
review: "Prüfung",
all: "Alle",
},
reviewScope: {
  yours: "Ihre",
  everyone: "Alle",
},
view: {
  calendarShort: "Kalender",
  listShort: "Liste",
  title: "Ansicht",
cards: "Listenansicht",
calendar: "Kalenderansicht",
},
type: {
request: "Anfragen",
inspection: "Prüfungen",
job: "Aufträge",
},
sort: {
urgency: "Dringlichkeit",
due: "Fälligkeitsdatum",
updated: "Zuletzt aktualisiert",
priority: "Priorität",
created: "Neueste",
},
group: {
asset: "Anlage",
site: "Standort",
assignee: "Zuständige Person",
status: "Status",
type: "Typ",
none: "Keine",
},
groupUrgent_one: "{{count}} dringend",
groupUrgent_other: "{{count}} dringend",
groupByLabel: "Gruppieren: {{axis}}",
groupByTitle: "Arbeit gruppieren nach",
collapseAll: "Alle einklappen",
expandAll: "Alle ausklappen",
collapseGroup: "{{name}} einklappen ({{count}})",
expandGroup: "{{name}} ausklappen ({{count}})",
groupOverdue: "Überfällig: {{count}}",
groupNeedsYou: "Braucht Sie: {{count}}",
groupDueSoon: "Bald fällig: {{count}}",
groupNew: "Neu: {{count}}",
groupTypeDocument: "Dokumente",
groupNone: { asset: "Keine Anlage", site: "Kein Standort", assignee: "Nicht zugewiesen" },
newLane: { title: "Neu seit Ihrem letzten Besuch", more: "{{count}} weitere anzeigen", fewer: "Weniger anzeigen" },
openAsset: "{{name}} öffnen",
report: {
all: "Beliebig",
has_report: "Hat Bericht",
awaiting_review: "Wartet auf Prüfung",
signed_off: "Abgenommen",
},
refine: {
button: "Filtern",
output: "Ausgabe",
type: "Typ",
asset: "Anlage",
site: "Standort",
assignee: "Zuständige Person",
unassigned: "Nicht zugewiesen",
urgency: "Dringlichkeit",
status: "Status",
review: "Prüfung",
reviewToggle: "Erfordert meine Prüfung",
time: "Zeitraum",
renewals: "Verlängerungen",
renewalsToggle: "Verlängerungen anzeigen",
sortBy: "Sortieren nach",
anyAsset: "Beliebige Anlage",
unnamedSite: "Unbenannter Standort",
unnamedAssignee: "Unbenannte Person",
anySite: "Beliebiger Standort",
anyone: "Beliebige Person",
assigneeFacetTeam: "Team",
assigneeFacetExternal: "Extern",
selectedCount_one: "{{count}} ausgewählt",
selectedCount_other: "{{count}} ausgewählt",
searchPlaceholder: "Suchen…",
searchAssetPlaceholder: "Anlagen suchen…",
removeAsset: "{{name}} entfernen",
searchSitePlaceholder: "Standorte suchen…",
searchAssigneePlaceholder: "Personen suchen…",
noMatches: "Keine Treffer.",
clear: "Zurücksetzen",
clearSelection: "Auswahl aufheben",
done: "Fertig",
},
timePreset: {
overdue: "Überfällig",
today: "Heute",
next_7: "Nächste 7 Tage",
},
urgencyBand: {
critical: "Kritisch",
high: "Hoch",
medium: "Mittel",
low: "Niedrig",
},
status: {
triage: "Neu",
scheduled: "Geplant",
in_progress: "In Bearbeitung",
awaiting_review: "Wartet auf Prüfung",
done: "Fertig",
cancelled: "Abgebrochen",
},
kanbanEmpty: {
triage: "Keine neuen Anfragen.",
scheduled: "Nichts geplant.",
in_progress: "Nichts in Bearbeitung.",
awaiting_review: "Nichts wartet auf Prüfung.",
done: "Noch nichts erledigt.",
cancelled: "Nichts abgebrochen.",
board: "Keine laufende Arbeit in dieser Ansicht.",
},
due: {
  inDays: "Fällig in {{n}} T.",
  overdueDays: "{{n}} T. überfällig",
overdue: "Überfällig",
today: "Heute fällig",
tomorrow: "Morgen fällig",
onDate: "Fällig am {{date}}",
},
badge: {
urgency: {
critical: "Dringend",
high: "Hoch",
},
rework: "Zurückgeschickt",
quotesDeclined: "Alle abgelehnt",
quotesWaiting: "Wartet auf Angebote",
awaitingRequester: "Wartet auf Antragsteller",
subJobsDone: "{{done}} von {{total}} Teilaufträgen erledigt",
subJobNeedsYou: "Teilauftrag braucht Sie",
partOf: "Teil von {{title}}",
partOfAJob: "Teil eines größeren Auftrags",
confirmVisit: "Termin bestätigen",
visitUnconfirmed: "Termin unbestätigt",
acceptancePending: "Annehmen oder ablehnen",
awaitingAcceptance: "Wartet auf Annahme",
awaitingVerification: "Wartet auf Verifizierung",
quoteInvited: "Angebotseinladung",
attention: {
overdue: "Überfällig",
awaiting_you: "Wartet auf Sie",
stalled: "Ins Stocken geraten",
unscheduled: "Nicht geplant",
expiring_soon: "Bald fällig",
},
column: {
triage: "Offen",
scheduled: "Geplant",
in_progress: "In Bearbeitung",
awaiting_review: "Wartet auf Prüfung",
},
review: {
awaiting_your_approval: "Genehmigen",
you_must_review: "Prüfen",
awaiting_recipient: "Wartet auf Antwort",
changes_requested: "Änderungen angefordert",
},
report: {
awaiting_repairs_conversion: "Genehmigte Reparaturen",
pending_signoff: "Bericht bereit",
signed_off: "Abgenommen",
},
done: {
completed: "Abgeschlossen",
verified: "Abgenommen",
rejected: "Abgelehnt",
cancelled: "Abgebrochen",
superseded: "Ersetzt",
skipped: "Übersprungen",
},
},
empty: "Momentan nichts vorhanden.",
emptyReports: "Noch keine Berichte. Ein Bericht erscheint hier, sobald eine Inspektion oder ein Auftrag einen hat.",
previewEmpty: "Wählen Sie einen Auftrag oder eine Anfrage aus, um sie hier zu bearbeiten.",
loadError: "Einige Arbeiten konnten nicht geladen werden ({{sources}}).",
retry: "Erneut versuchen",
loadingA11y: "Arbeit wird geladen",
preview: {
kind: {
job: "Auftrag",
request: "Anfrage",
inspection: "Prüfung",
schedule: "Prüfung",
document: "Dokument",
},
asset: "Anlage",
status: "Status",
due: "Fällig",
noDue: "Kein Fälligkeitsdatum",
assigned: "Zugewiesen",
unassigned: "Nicht zugewiesen",
site: "Standort",
report: "Bericht",
reportAvailable: "Verfügbar",
reportNone: "Nicht verfügbar",
openFull: "Vollständigen Datensatz öffnen",
openFullKind: "{{kind}} öffnen",
pin: "Bereich anheften",
unpin: "Anheftung aufheben",
collapse: "Bereich einklappen",
},
},
aiNextSteps: {
summaryReady: "{{ready}} von {{total}} bereit",
createdMore: "+{{count}} weitere",
openCreatedA11y: "{{label}} öffnen",
recordKind: {
job: "Auftrag anzeigen",
inspection_schedule: "Geplante Inspektion anzeigen",
request: "Anfrage anzeigen",
template: "Checkliste anzeigen",
},
title: "Vorgeschlagene nächste Schritte",
planning: "Die besten nächsten Schritte werden ermittelt …",
running: "Die bestätigten Schritte werden ausgeführt …",
empty: "Hier ist derzeit nichts zu tun.",
doAll: "Alle ausführen ({{total}})",
doStep: "Ausführen",
doStepA11y: "Diesen Schritt ausführen: {{step}}",
retry: "Erneut versuchen",
dismiss: "Ausblenden",
errorFallback: "Nächste Schritte konnten nicht vorgeschlagen werden.",
blocked: {
advisory: "Nur ein Hinweis – es wird nichts automatisch ausgeführt.",
missingDetails: "Es fehlen noch Angaben, bevor dies ausgeführt werden kann.",
},
outcome: {
executed: "Erledigt",
failed: "Dieser Schritt wurde nicht abgeschlossen.",
},
results: {
allDone: "Alle bestätigten Schritte abgeschlossen ({{total}}).",
partial: "{{executed}} abgeschlossen, {{failed}} fehlgeschlagen.",
},
confirm: {
title: "Bestätigen, was passiert",
intro: "Folgendes wird jetzt ausgeführt und ändert Ihre Daten ({{total}}):",
noDetail: "Keine weiteren Details verfügbar.",
run: "Jetzt ausführen",
cancel: "Abbrechen",
},
},
workflow: {
actions: {
requestedReview: "Prüfung angefordert",
approvedRepairs: "Reparaturen genehmigt",
assignedWork: "Arbeit zugewiesen",
scheduleProposed: "Termin vorgeschlagen",
workStarted: "Arbeit begonnen",
workPaused: "Arbeit pausiert",
workResumed: "Arbeit fortgesetzt",
completionSubmitted: "Abschluss eingereicht",
reworkRequested: "Nachbesserung angefordert",
workApproved: "Arbeit genehmigt",
jobAccepted: "Auftrag angenommen",
jobDeclined: "Auftrag abgelehnt",
quoteRequestSent: "Angebotsanfrage gesendet",
quoteSubmitted: "Angebot eingereicht",
quoteAccepted: "Angebot angenommen",
quoteRejected: "Angebot abgelehnt",
contractorAwarded: "Auftragnehmer beauftragt",
},
},
search: {
title: "Arbeit durchsuchen",
placeholder: "Prüfungen, Aufträge, Anfragen oder Anlagen durchsuchen",
triggerA11y: "Arbeit durchsuchen",
triggerHint: "Prüfungen, Aufträge, Anfragen oder Anlagen durchsuchen",
inputA11y: "Prüfungen, Aufträge, Anfragen oder Anlagen durchsuchen",
closeA11y: "Arbeitssuche schließen",
clearA11y: "Arbeitssuche zurücksetzen",
scope: {
all: "Alle",
inspections: "Prüfungen",
jobs: "Aufträge",
requests: "Anfragen",
},
scopeActive: "Nur {{type}} ✕",
groups: {
inspection: "Prüfungen",
job: "Aufträge",
request: "Anfragen",
asset: "Anlagen",
contact: "Kontakte",
},
refine: "Filtern",
refineCount: "Filtern {{count}}",
refineA11y_one: "Arbeitssuche filtern, {{count}} aktive Filterkategorie",
refineA11y_other: "Arbeitssuche filtern, {{count}} aktive Filterkategorien",
clearFilters: "Alle zurücksetzen",
filters: {
state: "Status",
scope: "Bereich",
all: "Alle",
open: "Offen",
completed: "Abgeschlossen",
mine: "Mir zugewiesen",
team: "Mein Team",
needsAttention: "Braucht Aufmerksamkeit",
},
minimumTitle: "Gesamte Arbeit durchsuchen",
recentsTitle: "Kürzlich",
recentsClear: "Löschen",
pinA11y: "Anheften, um oben zu bleiben",
unpinA11y: "Anheftung aufheben",
minimumBody: "Geben Sie mindestens zwei Zeichen ein, um autorisierte Prüfungen, Aufträge, Anfragen und Anlagen zu durchsuchen.",
loading: "Arbeit wird durchsucht…",
errorTitle: "Suche nicht verfügbar",
errorBody: "Die Arbeitssuche war nicht möglich. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
noResultsTitle: "Keine passende Arbeit",
noResultsBody: "Versuchen Sie einen anderen Titel, eine andere Referenz, Anlage, einen anderen Standort oder eine andere zuständige Person.",
viewAll: "Alle anzeigen",
viewAllA11y: "Alle {{type}}-Ergebnisse anzeigen",
result: {
type: {
inspection: "Prüfung",
job: "Auftrag",
request: "Anfrage",
asset: "Anlage",
contact: "Kontakt",
},
statusA11y: "Status {{status}}",
dateA11y: "Datum {{date}}",
assigneeA11y: "Zugewiesen an {{name}}",
},
},
hub: {
title: "Arbeit",
impactTitle: "Nur einige Anlagen",
impactBody_one: "Diese Liste zeigt nur Arbeit für {{count}} Anlage.",
impactBody_other: "Diese Liste zeigt nur Arbeit für {{count}} Anlagen.",
impactClear: "Alle anzeigen",
impactClearA11y: "Arbeit für alle Anlagen anzeigen",
tablistLabel: "Arbeit nach Typ filtern: Inspektionen, Aufträge oder Anfragen",
emptyViewAll: "Alle anzeigen",
segments: {
queue: "Meine Warteschlange",
inspections: "Inspektionen",
jobs: "Aufträge",
approvals: "Freigaben",
requests: "Anfragen",
templates: "Inspektions-Checklisten",
},
hints: {
queue: "Priorisierte Arbeit und Entscheidungen",
inspections: "Inspektionen, Prüfungen und Pläne anzeigen",
jobs: "Aufträge und Arbeitslast",
approvals: "Eingehende Anfragen und abgeschlossene Arbeit prüfen, die auf eine Entscheidung warten",
requests: "Eingehende Anfragen sichten; genehmigen, planen oder in Inspektionen oder Aufträge umwandeln",
templates: "Wiederverwendbare Inspektions-Checklisten",
inspectionsFilter: "Arbeit auf Inspektionen, Prüfungen und Pläne filtern. Erneut wählen, um alles anzuzeigen, was Sie betrifft.",
jobsFilter: "Arbeit auf Aufträge filtern. Erneut wählen, um alles anzuzeigen, was Sie betrifft.",
requestsFilter: "Arbeit auf eingehende Anfragen filtern. Erneut wählen, um alles anzuzeigen, was Sie betrifft.",
},
secondaryLabel: "Sekundär",
workflowLibrary: "Checklisten",
workflowLibraryShort: "Checklisten",
workflowLibraryHint: "Wiederverwendbare Inspektions-Checklisten",
workflowLibraryA11y: "Checklisten öffnen",
workflowLibraryBack: "Zurück zu Arbeit",
workflowLibraryBackHint: "Checklisten verlassen",
workflowLibraryBackA11y: "Zur Arbeitswarteschlange zurückkehren",
secondaryToolsTitle: "Betriebsberichte",
secondaryToolsSummary: "Berichte und Analysen.",
secondaryToolsMeta: "1 sekundäres Werkzeug",
status: {
attention: "Braucht Aufmerksamkeit",
inspections: "Offene Prüfungen",
jobs: "Offene Aufträge",
approvals: "Genehmigungen",
requests: "Anfragen",
},
nextAction: {
eyebrow: "Empfohlener nächster Schritt",
reviewApprovals: "Genehmigungen prüfen",
reviewApprovalsMeta: "Entscheiden Sie, welche eingehenden Anfragen und abgeschlossenen Arbeiten als Nächstes weitergehen.",
openQueue: "Alles anzeigen, was auf Sie wartet",
openQueueMeta: "Überfällig, heute fällig und blockiert.",
continueInspections: "Prüfungen fortsetzen",
continueInspectionsMeta: "Geplant, aktiv und abgeschlossen.",
continueJobs: "Aufträge fortsetzen",
continueJobsMeta: "Verantwortliche, Blocker, Termine, Status.",
backToQueue: "Zurück zu Arbeit",
backToQueueMeta: "Zurück zu allem, was auf Sie wartet.",
openWorkflows: "Prüfvorlagen öffnen",
openWorkflowsMeta: "Prüf-Checklisten erstellen oder wiederverwenden.",
},
},
queue: {
mobileFilter: {
all: "Alle",
overdue: "Überfällig",
today: "Heute",
approvals: "Genehmigungen",
a11y: "Warteschlange filtern: {{label}}",
},
focus: {
showing: "Zeigt {{label}} · {{count}}",
inProgress: "Arbeit in Bearbeitung",
attention: "Erfordert Sie",
clear: "Zurücksetzen",
clearA11y: "Filter zurücksetzen und die gesamte Warteschlange anzeigen",
showAll: "Alles anzeigen",
},
emptyFocused: "Nichts hier: {{label}}.",
refineGroupBy: "GRUPPIEREN NACH",
groupBy: {
asset: "Nach Anlage",
status: "Nach Status",
},
table: {
type: "Typ",
},
calendar: {
today: "Heute",
todayA11y: "Zu heute springen",
prevMonthA11y: "Vorheriger Monat",
nextMonthA11y: "Nächster Monat",
moreCount: "+{{count}} weitere",
emptyDay: "An diesem Tag ist nichts geplant",
dayA11y: "{{date}} — {{count}} geplant: {{summary}}",
dayEmptyA11y: "{{date}} — nichts geplant",
summaryAndMore: "{{titles}} und {{count}} weitere",
openItemA11y: "{{type}} öffnen: {{title}}",
unscheduledTitle: "Ohne Termin · {{count}}",
unscheduledHint: "Noch kein Datum. Öffnen Sie einen Eintrag, um ihm ein Datum zu geben.",
scheduleWork: "Arbeit planen",
scheduleSheetTitle: "Was möchten Sie planen?",
scheduleInspection: "Inspektion planen",
scheduleJob: "Auftrag planen",
filters: {
all: "Alle",
jobs: "Aufträge",
inspections: "Inspektionen",
requests: "Anfragen",
renewals: "Dokumente",
},
prevRangeA11y: "Vorherige zwei Wochen",
nextRangeA11y: "Nächste zwei Wochen",
upcoming: "Demnächst",
modeMonth: "Monat",
modeWeek: "Woche",
modeMonthA11y: "Monatsraster anzeigen",
modeWeekA11y: "Woche nach Stunden anzeigen",
prevWeekA11y: "Vorherige Woche",
nextWeekA11y: "Nächste Woche",
allDay: "Ganztägig",
weekItemA11y: "{{type}} um {{time}}: {{title}}",
},
itemKinds: {
job: "Auftrag",
inspection: "Prüfung",
request: "Anfrage",
document: "Dokument",
condition: "Zustand",
activity: "Aktivität",
quick_action: "Schnellaktion",
},
empty: "Die Warteschlange ist leer.",
emptyLine: "In diesem Kontext ist die Warteschlange leer.",
emptyBrowse: "Prüfungen öffnen",
emptyBrowseA11y: "Prüfregister öffnen",
searchPlaceholder: "Suche nach Anlage, ID, Verantwortlichem",
ungroupedSite: "Sonstiges",
hintFullLists: "Vollständige Listen in Inspektionen und Aufträgen.",
context: {
followUpTitle: "Nachverfolgung",
toolsTitle: "Checklisten",
reportIssue: "Störung melden",
flagProblem: "Mangel kennzeichnen",
requestFix: "Nachbesserung anfordern",
escalate: "Eskalieren",
reusePrevious: "Bestehendes wiederverwenden",
moreFollowUps: "Mehr",
moreFollowUpsSheetTitle: "Nachverfolgung oder Workflow erfassen",
},
sections: {
queueTitle: "Warteschlange",
overdue: "Überfällig · {{count}}",
dueToday: "Heute fällig · {{count}}",
certificateActions: "Fällige Zertifikate · {{count}}",
scheduledInspections: "Geplante Inspektionen · {{count}}",
inProgressJobs: "Aufträge in Bearbeitung · {{count}}",
needsAttention: "Aufmerksamkeit erforderlich · {{count}}",
reportReviews: "Berichtsprüfungen",
},
},
assetCollaboration: {
  respondBy: {
    days: "{{count}} T.",
    hours: "{{count}} Std.",
    minutes: "{{count}} Min.",
    overdue: "Überfällig seit {{window}}",
    dueIn: "Fällig in {{window}}",
  },
  requestType: {
    job: "Auftrag",
    inspection: "Inspektion",
    help: "Hilfe",
  },
  requestPriority: {
    urgent: "Dringend",
    high: "Hoch",
    medium: "Mittel",
    low: "Niedrig",
  },
  activityLabels: {
    lifecycleRecorded: "Erfasst",
    lifecycleBulk: "Sammeländerung",
    team: "Das Team",
    shareRole: {
      requester: "Anfragender",
      viewer: "Betrachter",
    },
    shareStatus: {
      revoked: "Widerrufen",
      declined: "Abgelehnt",
      active: "Aktiv",
      pending: "Wartet auf Annahme",
    },
    sharedWithContact: "Mit einem Kontakt geteilt",
    sharedWith: "Geteilt mit {{name}}",
    documentStatus: {
      no_expiry: "Kein Ablaufdatum",
      expired: "Abgelaufen",
      expiring_soon: "Läuft bald ab",
      valid: "Gültig",
    },
    connectedState: {
      planned: "Erfasst",
      outstanding: "Braucht Aufmerksamkeit",
      completed: "Gelöst",
    },
    connectedSource: "Verbundene Quelle",
    inspector: "Inspektor",
    unassigned: "Nicht zugewiesen",
    scheduledInspection: "Geplante Inspektion",
    type: {
      lifecycle: "Lebenszyklus",
      location: "Standort",
      access: "Zugriff",
      connected: "Verbundenes System",
      document: "Dokument",
      job: "Auftrag",
      inspection: "Inspektion",
    },
  },
  breadcrumbRequests: "Anfragen",
  evidenceFromRequest: "Fotos aus der Anfrage",
  conversation: {
    empty: "Noch keine Nachrichten. Senden Sie unten eine – {{who}} sieht sie und antwortet hier.",
    noneExchanged: "Zu dieser Anfrage wurden keine Nachrichten gesendet.",
  },
  closedBanner: {
    declinedRequester: "Diese Anfrage wurde ohne Umsetzung geschlossen.",
    declinedOp: "Diese Anfrage wurde abgelehnt oder zurückgezogen.",
    doneRequester: "Alles erledigt – Sie haben die Arbeit angenommen. Nichts mehr zu tun.",
    doneOp: "Die Arbeit ist erledigt und abgenommen. Diese Anfrage ist abgeschlossen.",
    teamClosed: "Das Team hat diese Anfrage geschlossen.",
    closedByTeam: "Ihr Team hat diese Anfrage geschlossen. Tippen Sie auf Wieder öffnen, wenn noch etwas zu tun ist.",
    closedByYou: "Sie haben diese Anfrage geschlossen. Tippen Sie auf Wieder öffnen, wenn noch etwas zu tun ist.",
    titleNotProceeding: "Geschlossen · Wird nicht umgesetzt",
    titleDone: "Geschlossen · Erledigt",
  },
  tracker: {
    next: "Als Nächstes:",
    active: "Offen seit {{age}}",
    closedTook: "Geschlossen · Dauer {{age}}",
    closed: "Geschlossen",
    progressA11yNow: "Fortschritt: {{done}} von {{total}} Schritten erledigt, jetzt {{stage}}",
    progressA11y: "Fortschritt: {{done}} von {{total}} Schritten erledigt",
  },
  row: {
    noAccountA11y: "ohne Konto gemeldet",
    noAccount: "Ohne Konto",
    contact: "Kontakt",
    unassigned: "Nicht zugewiesen",
    team: "Team",
    assigned: "Zugewiesen",
    preferred: "Gewünscht",
    scheduled: "Geplant",
  },
  showAll_other: "Alle anzeigen ({{count}})",
  showAll_one: "Alle anzeigen ({{count}})",
  showFewer: "Weniger anzeigen",
  messages: {
    newReplies_other: "{{count}} neue Antworten vom Team",
    newReplies_one: "{{count}} neue Antwort vom Team",
    open: "Dem Team schreiben",
    hide: "Nachrichten ausblenden",
  },
  period: {
    pm: "Nachmittag",
    am: "Vormittag",
  },
  withdraw: {
    confirm: "Zurückziehen",
    keep: "Behalten",
    body: "Damit werden die Anfrage und ein geplanter Besuch storniert, und das Team wird benachrichtigt.",
    title: "Diese Anfrage zurückziehen?",
    button: "Anfrage zurückziehen",
  },
  badge: {
    request: "Anfrage",
    job: "Auftrag",
    inspection: "Prüfung",
  },
  showDetailsA11y: "{{title}}. Details anzeigen",
  hideDetailsA11y: "{{title}}. Details ausblenden",
  collapseHide: "Ausblenden",
  expandShow: "Anzeigen",
  emptyAssetRequester: "Sie haben für diese Anlage noch nichts gemeldet.",
  sectionPendingRequester: "Gesendet — das Team sieht sie sich an",
  summary: {
    declined_other: "{{count}} abgelehnt",
    declined_one: "{{count}} abgelehnt",
    accepted_other: "{{count}} angenommen",
    accepted_one: "{{count}} angenommen",
    planned_other: "{{count}} geplant",
    planned_one: "{{count}} geplant",
    inProgress_other: "{{count}} in Arbeit",
    inProgress_one: "{{count}} in Arbeit",
    withTeam_other: "{{count}} beim Team",
    withTeam_one: "{{count}} beim Team",
    needsReply_other: "{{count}} brauchen Ihre Antwort",
    needsReply_one: "{{count}} braucht Ihre Antwort",
    toLookAt_other: "{{count}} zu prüfen",
    toLookAt_one: "{{count}} zu prüfen",
  },
  progress: {
    reports_other: "{{count}} Berichte",
    reports_one: "{{count}} Bericht",
    inspections_other: "{{count}} Prüfungen",
    inspections_one: "{{count}} Prüfung",
    jobs_other: "{{count}} Aufträge",
    jobs_one: "{{count}} Auftrag",
  },
  sort: {
    updated: "Kürzlich aktualisiert",
    oldest: "Älteste",
    newest: "Neueste",
  },
  displayStatus: {
    requester: {
      planned: "Geplant",
      accepted: "Angenommen",
      needsReview: "Braucht Ihre Prüfung",
      declined: "Abgelehnt",
      closed: "Geschlossen",
      waiting: "Braucht Ihre Antwort",
      active: "In Arbeit",
      triaged: "Genehmigt",
      new: "Gesendet",
    },
    operator: {
      declined: "Abgelehnt",
      closed: "Geschlossen",
      waiting: "Wartet auf die anfragende Person",
      active: "In Arbeit",
      triaged: "Genehmigt",
      new: "Neu",
    },
  },
  issueReportedConfirmInspection: "Problem erfasst. Checkliste und Zeit wählen, um die Prüfung zu buchen.",
  issueReportedConfirmJob: "Problem erfasst. Prüfen Sie den Auftrag und erstellen Sie ihn.",
  updateFailedTitle: "Die Anfrage wurde nicht aktualisiert",
  visitProposed: "Zeit vorgeschlagen. Die anfragende Person soll sie bestätigen.",
  requester: {
    contactMissing: "Ihr Konto konnte nicht mit dieser Anlage verbunden werden. Bitten Sie die teilende Person, sie erneut zu teilen.",
    assetMissing: "Diese Anlage wurde nicht gefunden. Öffnen Sie den erhaltenen Link erneut.",
    submitFailedTitle: "Ihre Meldung wurde nicht gesendet",
    calendarTitle: "Prüfung: {{name}}",
    reworkReason: "Die anfragende Person möchte, dass die Arbeit nachgebessert wird.",
    tryAgain: "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    declineShareFailed: "Nicht abgelehnt",
    acceptShareFailed: "Nicht angenommen",
    withdrawFailed: "Die Anfrage wurde nicht zurückgezogen",
    sendFailed: "Nicht gesendet",
    confirmFailed: "Nicht bestätigt",
    reviewFailed: "Ihre Antwort wurde nicht gespeichert",
    rescheduleFailed: "Ihre neue Zeit wurde nicht gesendet",
    confirmVisitFailed: "Besuch wurde nicht bestätigt",
    reportSent: "Meldung gesendet. Das Team sieht sie sich an; Neuigkeiten erscheinen hier und Sie werden benachrichtigt.",
    withdrawn: "Anfrage zurückgezogen. Das Team wurde benachrichtigt.",
    preferredTimeSent: "Gesendet. Das Team prüft Ihre Wunschzeit und meldet sich.",
    reworkRequested: "An das Team zurückgeschickt. Es hat Ihre Notiz und kümmert sich darum.",
    completionAccepted: "Danke – Sie haben die Arbeit angenommen. Das Team schließt die Anfrage.",
    rescheduleSent: "Andere Zeit angefragt. Das Team schlägt eine neue vor.",
    visitConfirmed: "Besuch bestätigt. Das Team wurde benachrichtigt.",
  },
  journey: {
    naReviewReport: "Bericht prüfen und Arbeit annehmen",
    naWaitingReviewOp: "Wartet auf die Prüfung der anfragenden Person",
    naTeamCloses: "Das Team bestätigt und schließt die Arbeit ab",
    naVerify: "Erledigte Arbeit bestätigen",
    naWorkUnderway: "Die Arbeit läuft",
    naWillSchedule: "Das Team plant die Arbeit ein",
    naVisitAsPlanned: "Das Team kommt wie geplant",
    naConfirmVisit: "Bestätigen Sie, dass jemand beim Besuch da ist",
    naCarryOut: "Arbeit ausführen",
    naScheduleJob: "Auftrag planen und starten",
    naHelpOp: "Antworten oder einen Auftrag erstellen",
    naStartInspection: "Prüfung starten",
    naTeamArranging: "Das Team plant die Arbeit",
    naPlanWork: "Arbeit planen",
    naCreateJob: "Auftrag erstellen",
    naScheduleInspection: "Prüfung planen oder starten",
    naTeamReviewing: "Das Team prüft Ihre Anfrage",
    naTriage: "Genehmigen, ablehnen oder eine Frage stellen",
    naWaitingOnRequester: "Wartet auf die anfragende Person",
    naReplyToTeam: "Dem Team antworten",
    detailTeamNote: "Notiz des Teams: {{notes}}",
    detailReason: "Grund: {{notes}}",
    slNewRequestOp: "Neue Anfrage.",
    slAllDone: "Alles erledigt.",
    slCompletedOp: "Abgeschlossen.",
    slReadyForReview: "Bereit für Ihre Prüfung.",
    slWaitingReviewOp: "Wartet auf die Prüfung der anfragenden Person.",
    slAccepted: "Sie haben die Arbeit angenommen — das Team bestätigt und schließt ab.",
    slAcceptedOp: "Von der anfragenden Person angenommen — bestätigen und schließen.",
    slWorkUnderway: "Die Arbeit läuft.",
    slWorkUnderwayOp: "Arbeit läuft.",
    slJobCreated: "Ein Auftrag wurde erstellt.",
    slJobCreatedOp: "Auftrag erstellt — noch nicht geplant.",
    slVisitPlanned: "Besuch geplant für {{when}}.",
    slJobPlannedOp: "Auftrag geplant für {{when}}.",
    slHelp: "Das Team kümmert sich darum.",
    slHelpOp: "Genehmigt — antworten oder einen Auftrag erstellen.",
    slInspectionUnderway: "Eine Prüfung läuft.",
    slInspectionUnderwayOp: "Prüfung läuft.",
    slInspectionScheduled: "Prüfung geplant für {{when}}.",
    slInspectionBookedOp: "Prüfung gebucht für {{when}}.",
    slApproved: "Genehmigt — das Team plant die Arbeit.",
    slApprovedOp: "Genehmigt — planen Sie die Arbeit.",
    slSubmitted: "Gesendet.",
    slNewOp: "Neu — sehen Sie sich diese Anfrage an.",
    slWaitingOnRequester: "Wartet auf weitere Angaben der anfragenden Person.",
    slWaitingOnYou: "Das Team braucht noch ein paar Angaben von Ihnen.",
    slDeclined: "Diese Anfrage wurde abgelehnt.",
    slDeclinedOp: "Abgelehnt.",
    stDone: "Erledigt",
    stClose: "Abschließen",
    stYourReview: "Ihre Prüfung",
    stReport: "Bericht",
    stSignOff: "Abnahme",
    stAnswered: "Beantwortet",
    stAnswer: "Antworten",
    stInProgress: "In Arbeit",
    stWork: "Arbeit",
    stInspecting: "Wird geprüft",
    stInspect: "Prüfen",
    stPlanned: "Geplant",
    stSchedule: "Planen",
    stReviewed: "Geprüft",
    stTriage: "Prüfung",
    stRaised: "Gesendet",
    stReceived: "Eingegangen",
  },
  requestConvert: {
    choose: "Nächsten Schritt wählen",
    inspectMeta: "Checkliste und Zeit wählen. Die Prüfung wird gebucht und bleibt mit der Anfrage verknüpft.",
    jobMeta: "Prüfen Sie, wer es macht, bis wann und die Anweisungen, dann erstellen Sie den Auftrag.",
    inspectInstead: "Stattdessen prüfen",
    inspect: "Prüfen",
    jobInstead: "Stattdessen Auftrag erstellen",
    job: "Auftrag erstellen",
    subtitle: "Die Angaben der Anfrage sind schon ausgefüllt. Sie bestätigen nur, wer es macht und wann.",
    title: "Was soll als Nächstes passieren?",
  },
  requestFulfilment: {
    unclear: "Unklar, was los ist: Eine Prüfung zeigt, welche Arbeit nötig ist.",
    urgentUnclear: "Es ist dringend, aber unklar: Schicken Sie jetzt jemanden, der vor Ort prüft.",
    readsAsCheck: "Es klingt nach einer Zustands- oder Sicherheitsprüfung, also zuerst prüfen.",
    describesFault: "Es beschreibt etwas zu Reparierendes, also ist ein Auftrag am schnellsten.",
    askedForJob: "Es wurde ein Auftrag angefragt.",
    askedForInspection: "Es wurde eine Prüfung angefragt.",
    assessFirst: "Erst prüfen, damit klar ist, welche Arbeit nötig ist.",
  },
tabLabel: "Nachverfolgungen",
tabTitle: "Nachverfolgungen & Triage",
tabIntro: "Nachverfolgungen erfassen und Kontaktanfragen prüfen.",
openApprovalsQueue: "Alle Anfragen unter Arbeit ansehen",
sectionCardTitle: "Anfragen zu dieser Anlage",
sectionCardSub: "Ein Problem erfassen oder alle Anfragen unter Arbeit ansehen.",
sectionCardSubRequester: "Ein Problem melden und verfolgen, was damit geschieht.",
newRequest: "Neue Anfrage",
composeItemTitle: "Checklistenpunkt der Inspektion",
composeItemDescription: "Referenzierter Punkt: {{itemId}}",
activityFollowUpLabel: "Erfasster Punkt",
activityAssetLabel: "Anlage",
activityAssetCreatedTitle: "Anlage hinzugefügt",
activityAssetCreatedStatus: "Erstellt",
activityAssistantChangeTitle: "Über den Assistenten geändert",
activityAssistantUndoneTitle: "Assistenten-Änderung rückgängig gemacht",
activityAssistantStatus: "Im Assistenten bestätigt",
activitySiteLabel: "Standort",
missingAssetForCompose: "Diese Anlage wurde nicht gefunden.",
missingLinkedContactForCompose: "Das Problem konnte nicht unter Ihrem Namen erfasst werden. Ab- und wieder anmelden, dann erneut versuchen.",
operatorLinkedContactNoAccount: "Ihr Profil ist noch keinem Konto im Arbeitsbereich zugeordnet. Melden Sie sich ab und wieder an. Wenn das Problem weiter besteht, wenden Sie sich an den Support.",
operatorLinkedContactAutoFailed: "Das Problem konnte nicht unter Ihrem Namen erfasst werden. Versuchen Sie es gleich erneut; sonst ab- und wieder anmelden.",
composeSubmitErrorTitle: "Senden nicht möglich",
issueReported: "Problem erfasst. Genehmigen Sie es oder tippen Sie auf Auftrag erstellen bzw. Prüfen, um die Arbeit zu planen.",
composeSubmitErrorBody: "Bitte erneut versuchen.",
composeOpenErrorTitle: "Öffnen nicht möglich",
sectionPending: "Neu",
sectionAwaitingCustomer: "Braucht Ihre Antwort",
sectionAwaitingCustomerInternal: "Wartet auf die anfragende Person",
sectionActive: "Genehmigt, geplant oder in Arbeit",
sectionClosed: "Abgeschlossen",
sectionRejected: "Abgelehnt",
emptyAsset: "Für diese Anlage wurde noch nichts gemeldet. Tippen Sie auf Neue Anfrage, um ein Problem zu erfassen.",
loadingFollowUps: "Nachverfolgungen werden geladen…",
emptySection: "In dieser Gruppe ist nichts.",
actionApprove: "Freigeben",
actionReject: "Ablehnen",
actionSchedule: "Planen",
actionConvert: "Vorgehen wählen",
metaContactFallback: "Kontakt",
metaNoPriority: "Keine Priorität",
metaNoDate: "Kein Wunschtermin",
outcomeTypeJob: "Nachverfolgter Auftrag",
outcomeTypeInspection: "Geplante Inspektion",
},
followUpDetail: {
managerActionsTitle: "Manager-Aktionen",
managerApprove: "Genehmigen",
managerReject: "Ablehnen",
managerSchedule: "Terminieren",
managerConvertJob: "In Auftrag umwandeln",
managerConvertInspection: "In Prüfung umwandeln",
summaryAssetHeadline: "Anlage",
summaryRequesterHeadline: "Antragsteller",
emptyLoadingTitle: "Wird geladen",
emptyLoadingBody: "Aktuelle Zusammenfassung und Verlauf werden abgerufen.",
emptySelectTitle: "Element auswählen",
emptySelectBody: "Wählen Sie ein Element aus, um Details und Aktionen anzuzeigen.",
outcomeKindJob: "Als Arbeit erfasst",
outcomeKindInspection: "Prüfung angefordert",
outcomeSummary: "Zusammenfassung",
fieldStatus: "Status",
fieldPriority: "Priorität",
fieldProposedDate: "Bevorzugter Zeitpunkt",
fieldScheduledFor: "Geplant für",
fieldResolution: "Notizen zur Lösung",
assetSummary: "Anlage",
fieldAssetName: "Anlage",
fieldAssetType: "Typ",
fieldAssetStatus: "Anlagenstatus",
reporter: "Eingereicht von",
fieldContactName: "Name",
fieldContactEmail: "E-Mail",
timeline: "Fortschritt",
timelinePending: "Ausstehend",
timelineDone: "Fertig",
history: "Verlauf",
historyEmpty: "Noch keine Verlaufseinträge.",
linkedWork: "Verknüpfte Arbeit",
openLinkedJob: "Verknüpften Auftrag öffnen",
openLinkedInspection: "Geplanten Termin öffnen",
actions: "Nächste Schritte",
actionApprove: "Genehmigen",
actionReject: "Ablehnen",
actionSchedule: "Terminieren",
actionConvert: "Arbeitspfad wählen",
loggedContext: "Herkunft",
fieldSourceInspection: "Prüfung",
fieldSourceJob: "Auftrag",
fieldSourceSchedule: "Geplanter Termin",
fieldSourceLocation: "Standortnotiz",
fieldIntent: "Art der Erfassung",
intentReport: "Problem melden",
intentFlag: "Problem kennzeichnen",
intentRequestFix: "Reparatur anfordern",
intentEscalate: "Eskalieren",
historyActionSubmitted: "Zur Triage erfasst",
historyActionApproved: "Genehmigt",
historyActionRejected: "Abgelehnt",
historyActionScheduled: "Geplant",
historyActionConvertedJob: "Auftrag aus Anfrage vorbereitet",
historyActionConvertedInspection: "Prüfung aus Anfrage vorbereitet",
historyActionCommented: "Kommentar hinzugefügt",
aiAssistDisclosureTitle: "Unterstützung & Entwürfe",
aiAssistDisclosureSummary: "Zusammenfassungen, Umformulierungen und Antwortvorschläge",
},
approvalsWorkspace: {
toolbarOpenAssetFollowUps: "Anlagen-Folgeaktionen öffnen",
toolbarChooseAsset: "Anlage wählen",
searchPlaceholder: "Suche nach Anlagen-ID",
applyAssetFilter: "Anlagenfilter anwenden",
applyTeamFilter: "Teamfilter anwenden",
listColumnFollowUp: "Folgeaktion",
listColumnStatus: "Status",
listColumnPriority: "Priorität",
listColumnDate: "Datum",
listPaneTitle: "Anfragen",
webStatusHint: "",
detailPaneTitle: "Detail",
mobileTitle: "Anfragen",
mobileSubtitle: "Folgeaktionen triagieren und Arbeit vorbereiten.",
loadingQueue: "Genehmigungen werden geladen…",
emptyQueue: "Keine Anfragen vorhanden",
emptyQueueHint: "Versuchen Sie die Segmente „Gesendet“ oder „Alle“, oder erweitern Sie den Bereich.",
filterInspection: "Prüfung",
filterJob: "Auftrag",
countPending: "Ausstehend",
countUrgent: "Dringend",
filterAssetPlaceholder: "Nach Anlagen-ID filtern",
filterTeamPlaceholder: "Nach Team-ID filtern",
statusFilterAll: "Alle",
statusFilterPending: "Ausstehend",
statusFilterApproved: "Genehmigt",
statusFilterScheduled: "Geplant",
statusFilterConverted: "Verknüpfte Arbeit",
statusFilterRejected: "Abgelehnt",
refine: "Filtern",
refineA11y: "Anfragefilter anpassen",
refineSheetTitle: "Anfragen filtern",
nameSearchPlaceholder: "Anfragen nach Namen suchen",
nameSearchA11y: "Anfragen nach Namen suchen",
},
requestComposer: {
  duplicateBodyMore_other: "„{{title}}“ und {{count}} weitere sind noch offen. Sie können Ihre trotzdem senden.",
  duplicateBodyMore_one: "„{{title}}“ und {{count}} weitere sind noch offen. Sie können Ihre trotzdem senden.",
  duplicateBody: "„{{title}}“ ist für diese Anlage noch offen. Sie können Ihre trotzdem senden.",
  duplicateSimilar: "Eine ähnliche Anfrage ist bereits offen",
  duplicateExact: "Das wurde vielleicht schon gemeldet",
  summaryMissing: "Fügen Sie zuerst eine kurze Zusammenfassung hinzu und versuchen Sie es erneut.",
  ai: {
    signInBody: "Ihre Sitzung ist abgelaufen. Melden Sie sich erneut an und fügen Sie das Foto hinzu.",
    signInTitle: "Zum Hinzufügen von Fotos anmelden",
    failedBody: "Gleich erneut versuchen oder Ihren Text behalten.",
    failedTitle: "Text konnte nicht überarbeitet werden",
    review: "Prüfen Sie ihn, bevor Sie ihn verwenden.",
    titleTitle: "Überarbeitete Zusammenfassung",
    detailsTitle: "Überarbeitete Details",
  },
titles: {
default: "Problem melden",
report: "Problem melden",
flag: "Mangel kennzeichnen",
requestFix: "Nachbesserung anfordern",
escalate: "Eskalieren",
followUp: "Folgearbeit vorschlagen",
rework: "Nacharbeit vorschlagen",
quote: "Angebot abgeben",
},
proposal: {
kindHeading: "Was schlagen Sie vor?",
kindFollowUp: "Folgearbeit",
kindRework: "Nacharbeit",
kindQuote: "Ein Angebot",
summaryPlaceholder: "z. B. Druckventil ersetzen",
detailsLabel: "Was zu tun ist und warum",
detailsPlaceholder: "Was Sie festgestellt haben, was Sie tun würden und was man wissen sollte",
submit: "Vorschlag senden",
},
close: "Schließen",
assetHeading: "Anlage",
assetChoose: "Anlage wählen",
assetSearchPlaceholder: "Nach Anlagenname suchen…",
assetTypeAll: "Alle Typen",
assetNoMatches: "Keine Anlagen entsprechen Suche und Filtern.",
dictate: "Diktieren",
dictationListening: "Hört zu…",
dictationProcessing: "Transkript wird eingefügt…",
dictationStopping: "Diktat wird beendet…",
dictationHeard: "Gehört: {{text}}",
aiPolish: "Mit KI überarbeiten",
contextHeading: "Kontext",
contextReporter: "Melder: {{name}}",
contextInspection: "Aus einer Prüfung",
contextJob: "Aus einem Auftrag",
contextSchedule: "Aus einem geplanten Besuch",
outcomeHeading: "Was soll das Team tun?",
outcomeHelp: "Nur Hilfe — noch unsicher",
outcomeJob: "Auftrag anfordern",
outcomeInspection: "Inspektion anfordern",
summaryLabel: "Kurzfassung",
summaryPlaceholder: "z. B. fehlgeschlagene Prüfung an Linie 2",
detailsLabel: "Was Sie gesehen haben",
summaryPlaceholderRequester: "z. B. Wasserhahn in der Küche tropft",
detailsLabelRequester: "Was ist das Problem?",
detailsPlaceholderRequester: "Was Ihnen aufgefallen ist, wo es ist und seit wann",
detailsPlaceholder: "Beobachtung, Risiko, Einschränkungen",
priorityLabel: "Priorität",
priorityNone: "Keine",
priorityPickerTitle: "Priorität",
proposedDateLabel: "Wunschtermin (optional)",
proposedDatePlaceholder: "Datum wählen",
submit: "Senden",
submitRequester: "Meldung senden",
submitting: "Wird gesendet…",
assetChangeAccessibility: "Anlage wechseln",
assetChange: "Ändern",
analyzeEvidence: "Fotos auslesen",
evidenceAddToDetails: "Extrahierten Text zu den Details hinzufügen",
},
followUpActionModal: {
  stop: "Stopp",
  draft: "Mit KI entwerfen",
  drafting: "Wird entworfen…",
  polishFailedBody: "Versuchen Sie es gleich noch einmal.",
  polishFailedTitle: "Notiz konnte nicht überarbeitet werden",
  draftFailedBody: "Erneut versuchen oder selbst schreiben.",
  draftFailedTitle: "Frage konnte nicht entworfen werden",
  polishReview: "Prüfen Sie die Notiz, bevor Sie sie verwenden.",
  draftReview: "Prüfen Sie sie vor dem Senden.",
  draftedMessageTitle: "Entworfene Frage",
  polishedNotesTitle: "Überarbeitete Notiz",
  phNotes: "Was sie wissen sollten, z. B. wann jemand vorbeikommt.",
  phReject: "Warum es nicht umgesetzt wird. Die anfragende Person sieht das.",
  phClose: "Warum wird sie geschlossen? Der Grund bleibt an der Anfrage.",
  phReplied: "Die Antwort, wie per E-Mail oder Telefon gegeben. Wird an der Anfrage gespeichert.",
  phAsk: "Was brauchen Sie? Die Frage kommt per E-Mail oder in der App an.",
  labelNotes: "Notiz an die anfragende Person (optional, sie sieht sie)",
  labelReject: "Grund (die anfragende Person sieht ihn)",
  labelClose: "Grund für das Schließen (optional, die anfragende Person sieht ihn)",
  labelReplied: "Was gesagt wurde (optional)",
  labelAsk: "Ihre Frage (die anfragende Person sieht sie)",
  aiFallbackLabel: "Anfrage",
  loadAssigneesFailed: "Die zuweisbaren Personen konnten nicht geladen werden. Erneut versuchen.",
  searchAssignees: "Personen suchen",
  loadingAssignees: "Personen werden geladen…",
  unassigned: "Noch niemand",
  confirmSchedule: "Diese Zeit vorschlagen",
  confirmClose: "Anfrage schließen",
  confirmReplied: "Antwort speichern",
  confirmAsk: "Frage senden",
  confirmReject: "Anfrage ablehnen",
  confirmApprove: "Genehmigen",
  closeTitle: "Anfrage schließen",
  repliedTitle: "Antwort festhalten",
  askTitle: "Der anfragenden Person eine Frage stellen",
approveTitle: "Anfrage freigeben",
rejectTitle: "Anfrage ablehnen",
scheduleTitle: "Termin planen",
convertTitle: "In Arbeit umwandeln",
cancel: "Abbrechen",
confirm: "Bestätigen",
saving: "Speichern…",
targetLabel: "Ergebnistyp",
targetJob: "Nachverfolgter Auftrag",
targetInspection: "Geplante Inspektion",
convertPickerTitle: "Umwandeln in",
},
inspections: {
screenTitle: "Inspektionen",
templates: "Checklisten",
runner: {
noItems: "Keine Elemente",
noItemsInGroup: "Keine Elemente in dieser Gruppe",
items_one: "{{count}} Element",
items_other: "{{count}} Elemente",
groups_one: "{{count}} Gruppe",
groups_other: "{{count}} Gruppen",
questions_one: "{{count}} Frage",
questions_other: "{{count}} Fragen",
questionsShort: "{{count}} Fr.",
groupOf: "Gruppe {{index}} von {{total}}",
groupOfShort: "Gruppe {{index}}/{{total}}",
itemOf: "Element {{index}} von {{total}}",
indexOfShort: "{{index}}/{{total}}",
inGroup: "In: {{group}}",
},
bulk: {
select: "Prüfungen auswählen",
selectA11y: "Mehrere Prüfungen für Sammelaktionen auswählen",
cancelSelection: "Abbrechen",
selected_one: "{{count}} ausgewählt",
selected_other: "{{count}} ausgewählt",
selectAllVisible: "Alle sichtbaren",
clearVisible: "Sichtbare abwählen",
selectAllA11y: "Alle sichtbaren Prüfungen auswählen",
deselectAllA11y: "Alle sichtbaren Prüfungen abwählen",
deleteInspections: "Löschen",
deleteConfirmTitle: "Prüfungen löschen",
deleteConfirmMessage_one: "{{count}} Prüfung löschen? Dies kann nicht rückgängig gemacht werden.",
deleteConfirmMessage_other: "{{count}} Prüfungen löschen? Dies kann nicht rückgängig gemacht werden.",
deleteConfirmAction: "Löschen",
keep: "Beibehalten",
deleteSuccess_one: "{{count}} Prüfung gelöscht",
deleteSuccess_other: "{{count}} Prüfungen gelöscht",
partialResult: "{{succeeded}} erledigt · {{failed}} übersprungen",
allFailedTitle: "Nichts geändert",
allFailedMessage: "Die ausgewählten Prüfungen konnten nicht gelöscht werden. Bitte versuchen Sie es erneut.",
},
createInspection: "Inspektion erstellen",
startInspection: "Inspektion starten",
searchA11y: "Inspektionen durchsuchen",
searchPlaceholderPlanned: "Geplante Inspektionen durchsuchen?",
searchPlaceholderDefault: "Inspektionen und Prüfungen durchsuchen?",
export: "Exportieren",
exportCsvA11y: "Inspektionen als CSV exportieren",
refine: "Filtern",
refineA11y: "Filter und Gruppierung anpassen",
refineSheetTitle: "Inspektionen filtern",
refineSearch: "Suchen",
clearFilters: "Filter zurücksetzen",
manageTemplates: "Checklisten",
statusSectionLabel: "Status",
bucketTablistLabel: "Inspektionsstatus: Alle, Handlungsbedarf, Geplant oder Verlauf",
statusHintLine: "Die Liste zeigt diesen Status.",
viewToggleToListA11y: "Geplante Inspektionen in Listenansicht wechseln",
viewToggleToCalendarA11y: "Geplante Inspektionen in Kalenderansicht wechseln",
buckets: {
all: "Alle",
needsAction: "Handlungsbedarf",
planned: "Geplant",
history: "Abgeschlossen",
},
subtitles: {
allNone: "Noch keine Prüfungen",
allCount_one: "{{count}} Prüfung",
allCount_other: "{{count}} Prüfungen",
needsActionNone: "Derzeit ist kein Handlungsbedarf",
needsActionCount_one: "{{count}} Eintrag erfordert Aufmerksamkeit",
needsActionCount_other: "{{count}} Einträge erfordern Aufmerksamkeit",
plannedNone: "Keine geplanten Inspektionen",
plannedCount_one: "{{count}} bevorstehende Inspektion",
plannedCount_other: "{{count}} bevorstehende Inspektionen",
historyNone: "Noch kein Inspektionsverlauf",
historyCount_one: "{{count}} abgeschlossene, genehmigte oder geprüfte Position",
historyCount_other: "{{count}} abgeschlossene, genehmigte oder geprüfte Positionen",
},
emptyFilteredTitle: "Keine passenden Einträge",
emptyFilteredSubtitle: "Ändern Sie die Suche oder setzen Sie die Filter zurück.",
emptyPlannedTitle: "Keine Inspektionen unter Geplant",
emptyPlannedSubtitle: "Erstellen Sie eine geplante Inspektion über eine Anlage oder eine Checkliste; sie erscheint dann hier.",
emptyCalendarTitle: "Keine geplanten Prüfungen",
emptyCalendarSubtitle: "Der Kalender zeigt Prüfungen mit einem geplanten Termin. Wechseln Sie zu Karten oder Liste, um hier alle Prüfungen zu sehen.",
emptyHistoryTitle: "Keine Inspektionen im Verlauf",
emptyHistorySubtitle: "Abgeschlossene und geprüfte Inspektionen erscheinen hier, sobald sie abgeschlossen sind.",
emptyAllTitle: "Noch keine Prüfungen",
emptyAllSubtitle: "Prüfungen, Bewertungen und Termine werden hier angezeigt.",
emptyNeedsActionTitle: "Keine Inspektionen mit Handlungsbedarf",
emptyNeedsActionSubtitle: "Wenn Inspektionen Ihre Aufmerksamkeit brauchen, erscheinen sie in dieser Liste.",
followUp: {
logFromItem: "Aus Checklistenpunkt protokollieren",
},
refineScope: "Kontext",
refineGroupBy: "Gruppieren nach",
refineGroupByHint: "Eine oder mehrere Optionen für verschachtelte Gruppen wählen",
refineFilters: "Filter",
refineInspectionStage: "Inspektionsphase",
refineScheduleStage: "Planungsphase",
filterChipAsset: "Anlage",
filterChipTemplate: "Checkliste",
filterChipInspector: "Inspektor",
groupByAsset: "Anlage",
groupByInspector: "Inspektor",
groupByTemplateCategory: "Checklistenkategorie",
groupingUnassigned: "Nicht zugewiesen",
groupingUncategorized: "Ohne Kategorie",
inspectorAll: "Alle",
inspectorMe: "Ich",
inspectionStages: {
all: "Alle Inspektionsphasen",
allShort: "Alle Phasen",
draft: "Entwurf",
inProgress: "In Bearbeitung",
completed: "Abgeschlossen",
approved: "Genehmigt",
cancelled: "Abgebrochen",
},
scheduleStages: {
all: "Alle Planungsphasen",
allShort: "Alle",
upcoming: "Bevorstehend",
due: "Fällig",
overdue: "Überfällig",
},
reviewStages: {
pending: "Prüfung ausstehend",
responded: "Prüfung beantwortet",
awaitingReply: "Geteilt — wartet auf Antwort",
awaitingVerification: "Wartet auf Verifizierung",
column: {
triage: "Offen",
scheduled: "Geplant",
in_progress: "In Bearbeitung",
awaiting_review: "Wartet auf Prüfung",
},
},
kanban: {
dueAndOverdue: "Fällig & überfällig",
},
workflowStage: {
draft: "Entwurf",
in_progress: "In Bearbeitung",
completed: "Abgeschlossen",
approved: "Genehmigt",
cancelled: "Abgebrochen",
},
pickerAllTemplates: "Alle Checklisten",
pickerTitleAsset: "Anlage",
pickerTitleTemplate: "Checkliste",
pickerTitleInspector: "Inspektor",
reviewFallbackReport: "Inspektionsbericht",
reviewFallbackAsset: "Anlage",
reviewStatusApproved: "Genehmigt",
reviewStatusDeclined: "Abgelehnt",
reviewStatusPending: "Prüfung ausstehend",
resultsPanelA11y: "Inspektionsergebnisse für den gewählten Bereich",
fabCreateA11y: "Inspektion erstellen",
exportCsv: {
id: "ID",
template: "Checkliste",
asset: "Anlage",
status: "Status",
stage: "Phase",
assignee: "Zugewiesen",
lastActivity: "Letzte Aktivität",
},
operationalInsight: {
title: "Einblick ins Prüfregister",
sourceLabel: "Vorhandene Prüfungen, Termine und Bewertungen",
summaryLine: "{{bucketNeedsAction}} brauchen Aufmerksamkeit · {{planned}} geplant · {{history}} abgeschlossen in diesem Bereich",
overdueSchedExplanation_one: "{{count}} geplante Prüfung ist überfällig.",
overdueSchedExplanation_other: "{{count}} geplante Prüfungen sind überfällig.",
overdueSchedRecommended: "Starten oder verschieben Sie sie, damit Abdeckung und Konformität eingehalten werden.",
overdueSchedCta: "Überfällige Termine anzeigen",
pendingReviewExplanation_one: "{{count}} geteilter Bericht wartet auf eine Rückmeldung des Prüfers.",
pendingReviewExplanation_other: "{{count}} geteilte Berichte warten auf eine Rückmeldung des Prüfers.",
pendingReviewRecommended: "Antworten Sie oder erinnern Sie Prüfer, damit Genehmigungen nicht blockiert werden.",
pendingReviewCta: "Nächste Prüfung öffnen",
dueSoonExplanation_one: "{{count}} geplante Prüfung ist bald fällig.",
dueSoonExplanation_other: "{{count}} geplante Prüfungen sind bald fällig.",
dueSoonRecommended: "Bestätigen Sie, wer sie durchführt, und erfassen Sie nötige Vorarbeiten.",
dueSoonCta: "Fällige Termine anzeigen",
inProgressExplanation_one: "{{count}} Prüfung ist im Entwurf oder in Bearbeitung.",
inProgressExplanation_other: "{{count}} Prüfungen sind im Entwurf oder in Bearbeitung.",
inProgressRecommended: "Setzen Sie Checklisten fort, erfassen Sie Nachweise und übergeben Sie bei Bedarf.",
inProgressCta: "Auf laufende fokussieren",
healthyExplanation: "Keine ausstehenden Prüfungen oder überfälligen Termine in dieser gefilterten Ansicht.",
healthyRecommended: "Nutzen Sie Filtern, um Bereich, Gruppierung oder Suche anzupassen, wenn Sie eine engere Liste brauchen.",
refineCta: "Filtern öffnen",
exportCsvLabel: "Prüfungen exportieren (CSV)",
wideCollapsedLead: "Für Aktionen erweitern.",
widePanelLead: "Aktionen passen zu dieser Ansicht.",
},
tableHeaderWorkItem: "Arbeitselement",
tableHeaderStatus: "Status",
tableHeaderAssigned: "Zugewiesen",
tableHeaderDueDate: "Fälligkeitsdatum",
},
templates: {
  addIndustryPack: "Branchenpaket hinzufügen",
  emptyNoneSubtitlePacks: "Fügen Sie die fertigen Checklisten Ihrer Branche hinzu oder erstellen Sie eine eigene.",
screenTitle: "Checklisten",
createManually: "Manuell erstellen",
createManuallyA11y: "Manuell erstellen",
refineScope: "Bereich",
subtitleCount_one: "{{count}} Checkliste",
subtitleCount_other: "{{count}} Checklisten",
fromPack_one: "{{count}} aus dem Paket {{pack}}",
fromPack_other: "{{count}} aus dem Paket {{pack}}",
inspectionsLink: "Prüfungen",
searchPlaceholder: "Checklisten suchen…",
searchPlaceholderWeb: "Checklisten, Kategorien oder Beschreibungen durchsuchen",
searchA11y: "Checklisten durchsuchen",
refine: "Filtern",
refineSheetTitle: "Checklisten filtern",
refineGroupBy: "Gruppieren nach",
refineGroupByHint: "Wählen Sie eine oder mehrere Optionen, um Gruppen zu verschachteln",
refineFilters: "Filter",
filterAssetType: "Anlagentyp",
filterCategory: "Kategorie",
groupByAssetType: "Anlagentyp",
groupByCategory: "Kategorie",
pickerTitleAssetType: "Anlagentyp",
pickerTitleCategory: "Kategorie",
allTypes: "Alle Typen",
allCategories: "Alle Kategorien",
statusSectionLabel: "Status",
bucketTablistLabel: "Checklistenstatus: Handlung erforderlich, Geplant oder Verlauf",
statusHintLine: "Handlung erforderlich, geplant und Verlauf.",
refineA11y: "Checklistenfilter anpassen",
clear: "Zurücksetzen",
clearA11y: "Suche und Filter zurücksetzen",
generateWithAi: "Mit KI generieren",
createChooserTitle: "Checkliste erstellen",
createChooserSubtitle: "Wählen Sie, wie Sie Ihre Checkliste erstellen.",
newTemplate: "Neue Checkliste",
createTemplate: "Checkliste erstellen",
createTemplateA11y: "Checkliste erstellen",
newTemplateA11y: "Neue Checkliste",
emptyNoneTitle: "Noch keine Checklisten-Checklisten",
emptyNoneSubtitle: "Erstellen Sie eine Checklisten-Checkliste.",
emptyFilteredTitle: "Keine passenden Checklisten",
emptyFilteredSub: "Versuchen Sie andere Suchbegriffe oder setzen Sie die Filter zurück.",
clearFilters: "Filter zurücksetzen",
emptyBucketTitle: "Keine Checklisten in {{bucket}}",
emptyBucketSub: "Bereich wechseln oder Filter zurücksetzen.",
goToNeedsAction: "Zu „Handlung erforderlich“",
goToNeedsActionA11y: "Checklisten in „Handlung erforderlich“ anzeigen",
inspectorHeading: "Inspektor",
compatibility: "Kompatibilität",
versioning: "Versionierung",
structure: "Struktur",
visibility: "Sichtbarkeit",
description: "Beschreibung",
versioningCurrentId: "Aktuelle Versions-ID: {{id}}",
versioningNotSet: "Nicht festgelegt",
lastUpdatedPrefix: "Zuletzt aktualisiert",
structureLine: "{{groups}} Gruppen / {{items}} Elemente / {{conditional}} bedingte Regeln",
requiredChecks_one: "{{count}} erforderliche Prüfung",
requiredChecks_other: "{{count}} erforderliche Prüfungen",
visibilityAllTeams: "Alle Teams",
visibilitySelectedTeams: "Ausgewählte Teams",
openTemplate: "Checkliste öffnen",
edit: "Bearbeiten",
useForInspection: "Inspektion starten",
detail: {
duplicate: "Duplizieren",
delete: "Löschen",
sharedBadge: "Geteilt",
notFound: "Prüfvorlage nicht gefunden",
restrictToSelectedTeams: "Auf ausgewählte Teams beschränken",
shareWithAllTeams: "Für alle Teams freigeben",
visibleToAllTeams: "Für alle Teams sichtbar",
deleteConfirmTitle: "Prüfvorlage löschen",
deleteConfirmBody: "„{{name}}“ löschen? Frühere Prüfungen, die diese Checkliste verwendet haben, behalten ihren Datensatz.",
cancel: "Abbrechen",
duplicatedTitle: "Dupliziert",
duplicatedBody: "Eine Kopie dieser Prüfvorlage wurde erstellt.",
errorTitle: "Etwas ist schiefgelaufen",
failedToDelete: "Diese Checkliste konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.",
failedToDuplicate: "Diese Checkliste konnte nicht dupliziert werden. Bitte versuchen Sie es erneut.",
failedToUpdate: "Diese Checkliste konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.",
usedByTitle: "Verwendet in",
usedByCount_one: "{{count}} Prüfung",
usedByCount_other: "{{count}} Prüfungen",
usedByEmpty: "Diese Checkliste wurde noch von keiner Prüfung verwendet.",
usedByOpenInspection: "Prüfung öffnen",
},
selectTemplateTitle: "Checkliste auswählen",
selectTemplateSub: "Wählen Sie eine Zeile, um Struktur, Versionen und Nutzungsaktionen zu prüfen.",
groupingUncategorized: "Nicht kategorisiert",
labelGeneral: "Allgemein",
labelAllAssets: "Alle Anlagen",
fabNewTemplateA11y: "Neue Checkliste",
buckets: {
all: "Alle",
needsAction: "Handlung erforderlich",
planned: "Geplant",
history: "Verlauf",
},
},
jobs: {
followUp: {
requestFix: "Reparatur anfordern",
escalate: "Eskalieren",
logForTriage: "Folgeaktion erfassen",
logForTriageHint: "Öffnet die Folgeaktionen dieser Anlage mit Auftragskontext für Genehmigungen.",
},
operationalInsight: {
summaryEmpty: "Keine Aufträge entsprechen dem aktuellen Bereich und den Filtern.",
summaryCounts: "{{total}} Aufträge in dieser Ansicht · {{overdue}} überfällig · {{unassigned}} nicht zugewiesen · {{unscheduled}} ohne geplanten Start",
overdueExplanation_one: "{{count}} Auftrag hat den geplanten Start- oder Fälligkeitstermin überschritten.",
overdueExplanation_other: "{{count}} Aufträge haben den geplanten Start- oder Fälligkeitstermin überschritten.",
overdueRecommended: "Bestätigen Sie die Zuständigkeit, verschieben Sie den Termin oder schließen Sie bereits erledigte Arbeit ab.",
overdueCta: "Überfällige anzeigen",
unassignedExplanation_one: "{{count}} offener Auftrag hat keine zuständige Person.",
unassignedExplanation_other: "{{count}} offene Aufträge haben keine zuständige Person.",
unassignedRecommended: "Weisen Sie jedem Auftrag eine zuständige Person zu, damit Verantwortliche, Kunden und Auftragnehmer wissen, wer die Arbeit vorantreibt.",
unassignedCta: "Nicht zugewiesene anzeigen",
unscheduledExplanation_one: "{{count}} angenommener Auftrag benötigt noch einen geplanten Start.",
unscheduledExplanation_other: "{{count}} angenommene Aufträge benötigen noch einen geplanten Start.",
unscheduledRecommended: "Legen Sie ein Startfenster fest, bevor sich die Arbeit verzögert oder mit anderen Terminen kollidiert.",
unscheduledCta: "Nicht geplante anzeigen",
urgentExplanation_one: "{{count}} Auftrag ist als sehr dringend markiert.",
urgentExplanation_other: "{{count}} Aufträge sind als sehr dringend markiert.",
urgentRecommended: "Prüfen Sie auf Blocker, fehlende Nachweise und für Kunden sichtbare Verzögerungen.",
urgentCta: "Nach hoher Dringlichkeit filtern",
healthyExplanation: "Keine überfälligen, nicht zugewiesenen oder ungeplanten Aufträge in dieser gefilterten Ansicht.",
healthyRecommended: "Halten Sie Termine, zuständige Personen und Updates aktuell, während die Arbeit fortschreitet.",
healthyCta: "Filter anpassen",
exportCsvLabel: "Sichtbare Aufträge exportieren (CSV)",
wideCollapsedLead: "Für Aktionen erweitern.",
widePanelLead: "Aktionen passen zu dieser Ansicht.",
},
screenTitle: "Aufträge",
createJob: "Auftrag erstellen",
createJobA11y: "Auftrag erstellen",
searchPlaceholder: "Aufträge suchen…",
searchPlaceholderWeb: "Aufträge, Anlagen, zuständige Personen durchsuchen…",
searchA11y: "Aufträge durchsuchen",
refine: "Filtern",
refineSheetTitle: "Aufträge filtern",
refineSearch: "Suche",
refineJobsA11y: "Auftragsfilter anpassen",
refineScope: "Bereich",
refineGroupBy: "Gruppieren nach",
refineGroupByHint: "Wählen Sie eine oder mehrere Optionen, um Gruppen zu verschachteln",
refineFilters: "Filter",
refineStage: "Phase",
refineQuoteWorkflow: "Angebotsworkflow",
clearFilters: "Filter zurücksetzen",
advancedFiltersTitle: "Erweiterte Filter & Sortierung",
advancedFiltersSummary_one: "{{count}} Filter aktiv",
advancedFiltersSummary_other: "{{count}} Filter aktiv",
advancedFiltersSummaryEmpty: "Gruppieren, Filter, Phase, Bereich, Sortierung",
advancedFiltersExpand: "Filter anzeigen",
advancedFiltersCollapse: "Filter ausblenden",
exportFilteredCsvA11y: "Aktuell gefilterte Aufträge als CSV exportieren",
statusSectionLabel: "Status",
bucketTablistLabel: "Auftragsstatus: Alle, Handlung erforderlich, Geplant oder Verlauf",
statusHintLine: "Die Warteschlange entspricht diesem Bereich.",
switchToListA11y: "Aufträge zur Listenansicht wechseln",
switchToCalendarA11y: "Aufträge zur Kalenderansicht wechseln",
bucketsNative: {
all: "Alle",
needs_action: "Handlung erforderlich",
scheduled: "Geplant",
closed: "Abgeschlossen",
},
bucketsWeb: {
all: "Alle",
needs_action: "Handlung erforderlich",
scheduled: "Geplant",
closed: "Verlauf",
},
sort: {
newest: "Neueste zuerst",
oldest: "Älteste zuerst",
name_az: "Name A-Z",
name_za: "Name Z-A",
asset_name: "Anlagenname",
highest_cost: "Höchste Kosten",
lowest_cost: "Niedrigste Kosten",
assignee: "Zuständige Person",
},
sortBy: "Sortieren nach",
groupBy: {
asset: "Anlage",
status: "Status",
},
attention: {
all: "Alle",
overdue: "Überfällig",
unscheduled: "Nicht geplant",
},
webQueue: {
all: "Alle aktiv",
overdue: "Überfällig",
awaiting_acceptance: "Wartet auf Annahme",
unscheduled: "Nicht geplant",
in_progress: "In Bearbeitung",
due_soon: "Bald fällig",
other: "Später geplant",
},
quoteState: {
all: "Alle Angebotsstatus",
awaiting_request: "Wartet auf Angebotsanfrage",
requested: "Angebotsanfrage verknüpft",
awarded: "Angebot beauftragt",
},
quoteLinked: "Verknüpft",
quoteNone: "Keine",
priority: {
all: "Alle",
low: "Niedrig",
medium: "Mittel",
high: "Hoch",
critical: "Kritisch",
},
deliveryAll: "Alle",
deliveryMode: {
INTERNAL: "Intern",
DIRECT_CONTRACTOR: "Direkter Auftragnehmer",
PRIVATE_QUOTES: "Private Angebote",
},
categoryAll: "Alle Kategorien",
assigneeAll: "Alle zuständigen Personen",
assigneeUnassigned: "Nicht zugewiesen",
assigneeAssignedFallback: "Zugewiesen",
filterChip: {
asset: "Anlage",
category: "Kategorie",
workPath: "Arbeitspfad",
priority: "Priorität",
attention: "Aufmerksamkeit",
sort: "Sortierung",
assignee: "Zuständige Person",
quoteState: "Angebotsstatus",
},
pickerTitle: {
asset: "Anlage",
category: "Kategorie",
workPath: "Arbeitspfad",
priority: "Priorität",
sortBy: "Sortieren nach",
attention: "Aufmerksamkeit",
assignee: "Zuständige Person",
quoteState: "Angebotsstatus",
},
stages: {
all: {
all: "Alle",
},
needs_action: {
all: "Alle",
draft: "Entwurf",
open: "Offen",
accepted: "Angenommen",
completed: "Abgeschlossen",
rejected: "Abgelehnt",
},
scheduled: {
all: "Alle",
scheduled: "Geplant",
in_progress: "In Bearbeitung",
paused: "Pausiert",
},
closed: {
all: "Alle",
verified: "Verifiziert",
cancelled: "Abgebrochen",
},
},
grouping: {
noAsset: "Keine Anlage",
noSkill: "Keine Qualifikation",
unassigned: "Nicht zugewiesen",
uncategorized: "Nicht kategorisiert",
},
analytics: {
assigneeChannel: {
unassigned: "Nicht zugewiesen",
team_member: "Teammitglied",
contractor: "Auftragnehmer",
type_unset: "Zuständige Person (Typ nicht festgelegt)",
},
privateQuotesPipeline: {
awaitingRequest: "Noch keine Angebotsanfrage",
requested: "Wartet auf Beauftragung",
awarded: "Angebot beauftragt (in Bearbeitung)",
},
notSet: "Nicht festgelegt",
},
urgency: {
normal: "Normal",
low: "Niedrig",
medium: "Mittel",
high: "Hoch",
},
relative: {
justNow: "Gerade eben",
minutesAgo: "vor {{count}} Min.",
hoursAgo: "vor {{count}} Std.",
},
sortDash: "-",
alerts: {
cancelTitle: "Auftrag abbrechen",
cancelMessage: "Sind Sie sicher? Der Auftrag wird als abgebrochen markiert.",
keep: "Beibehalten",
cancelConfirm: "Auftrag abbrechen",
deleteTitle: "Auftrag löschen",
deleteMessage: "Dies kann nicht rückgängig gemacht werden. Der Auftrag wird endgültig entfernt.",
deleteConfirm: "Löschen",
errorTitle: "Fehler",
failedCancel: "Abbrechen fehlgeschlagen",
failedDelete: "Löschen fehlgeschlagen",
acceptFailedTitle: "Auftrag konnte nicht angenommen werden",
acceptFailedMessage: "Bitte versuchen Sie es erneut.",
},
bulk: {
select: "Aufträge auswählen",
selectA11y: "Mehrere Aufträge für Sammelaktionen auswählen",
cancelSelection: "Abbrechen",
selected_one: "{{count}} ausgewählt",
selected_other: "{{count}} ausgewählt",
selectAllVisible: "Alle sichtbaren",
clearVisible: "Sichtbare abwählen",
selectAllA11y: "Alle sichtbaren Aufträge auswählen",
deselectAllA11y: "Alle sichtbaren Aufträge abwählen",
cancelJobs: "Abbrechen",
deleteJobs: "Löschen",
cancelConfirmTitle: "Aufträge abbrechen",
cancelConfirmMessage_one: "{{count}} Auftrag abbrechen? Er wird als abgebrochen markiert.",
cancelConfirmMessage_other: "{{count}} Aufträge abbrechen? Sie werden als abgebrochen markiert.",
cancelConfirmAction: "Aufträge abbrechen",
deleteConfirmTitle: "Aufträge löschen",
deleteConfirmMessage_one: "{{count}} Auftrag löschen? Dies kann nicht rückgängig gemacht werden.",
deleteConfirmMessage_other: "{{count}} Aufträge löschen? Dies kann nicht rückgängig gemacht werden.",
deleteConfirmAction: "Löschen",
keep: "Beibehalten",
noneCancellable: "Keiner der ausgewählten Aufträge kann abgebrochen werden.",
cancelSuccess_one: "{{count}} Auftrag abgebrochen",
cancelSuccess_other: "{{count}} Aufträge abgebrochen",
deleteSuccess_one: "{{count}} Auftrag gelöscht",
deleteSuccess_other: "{{count}} Aufträge gelöscht",
partialResult: "{{succeeded}} erledigt · {{failed}} übersprungen",
allFailedTitle: "Nichts geändert",
allFailedMessage: "Die ausgewählten Aufträge konnten nicht aktualisiert werden. Bitte versuchen Sie es erneut.",
},
emptyNoJobs: "Keine Aufträge",
emptyNoMatching: "Keine passenden Aufträge",
emptyFilteredHint: "Versuchen Sie andere Suchbegriffe oder setzen Sie die Filter zurück.",
subtitleAttentionSummary: "{{overdue}} überfällig · {{unscheduled}} nicht geplant",
webSubtitleSummary: "{{total}} Aufträge · {{overdue}} überfällig · {{inProgress}} in Bearbeitung · {{dueSoon}} bald fällig",
noAssetLinked: "Keine Anlage verknüpft",
metaAsset: "Anlage",
metaPriority: "Priorität",
overview: {
queue: "Warteschlange",
status: "Status",
assignee: "Zuständige Person",
workPath: "Arbeitspfad",
schedule: "Termin",
nextStep: "Nächster Schritt",
started: "Gestartet",
completed: "Abgeschlossen",
duration: "Dauer",
quoteState: "Angebotsstatus",
summary: "Zusammenfassung",
inspection: "Prüfung",
},
notSet: "nicht festgelegt",
emDash: "—",
nextStepFallback: "In den vollständigen Details prüfen",
workflowNextStep: {
awaitingFollowOn: "Wartet auf Folgegenehmigung",
draft: "Details prüfen und Auftrag öffnen",
openAwaitingAcceptance: "Auftrag annehmen oder ablehnen",
openSchedule: "Auftrag terminieren",
openAssign: "Auftrag zuweisen",
rejected: "Ablehnung prüfen und neu zuweisen",
scheduled: "Auftrag starten",
inProgress: "Abschließen oder pausieren",
inProgressRework: "Abschluss erneut einreichen",
paused: "Fortsetzen oder neu terminieren",
completed: "Verifizieren oder Nachbesserung anfordern",
},
verifyCompletion: {
title: "Auftrag abzeichnen",
message: "Diesen Auftrag abzeichnen? Die zuständige Person wird benachrichtigt.",
confirm: "Abzeichnen",
},
video: {
unsupportedSource: "Dieses Video kann von diesem Speicherort nicht abgespielt werden.",
loadFailed: "Video konnte nicht geladen werden.",
},
notScheduled: "Nicht geplant",
openInspectionA11y: "Prüfung {{label}} öffnen",
media: {
closeImageViewer: "Bildansicht schließen",
closeVideoViewer: "Videoplayer schließen",
},
kpi: {
overdueLabel: "Überfällig",
overdueSub: "Erfordert sofortiges Handeln",
inProgressLabel: "In Bearbeitung",
inProgressSub: "Wird derzeit ausgeführt",
dueSoonLabel: "Bald fällig",
dueSoonSub: "Nächste 72 Stunden",
},
command: {
openCalendar: "Kalender öffnen",
createJob: "Auftrag erstellen",
refine: "Filtern",
clearFilters: "Filter zurücksetzen",
exportCsv: "CSV exportieren",
},
exportCsvHeaders: {
title: "Titel",
status: "Status",
asset: "Anlage",
priority: "Priorität",
assignee: "Zuständige Person",
updated: "Aktualisiert",
},
inspector: {
openJob: "Auftrag öffnen",
addUpdate: "Update hinzufügen",
accept: "Annehmen",
reject: "Ablehnen",
assign: "Zuweisen",
schedule: "Terminieren",
start: "Starten",
pause: "Pausieren",
resume: "Fortsetzen",
complete: "Abschließen",
approve_rework: "Nachbesserung genehmigen",
verify: "Verifizieren",
rework: "Nachbesserung",
},
workQueueHeading: "Arbeitswarteschlange",
queueEmpty: "Keine Aufträge in dieser Warteschlange.",
emptyMatchingWebTitle: "Keine passenden Aufträge",
emptyMatchingWebSub: "Versuchen Sie eine andere Warteschlange oder setzen Sie die Filter zurück.",
emptyBucketTitle: "Keine Aufträge in {{bucket}}",
emptyBucketSub: "Wechseln Sie zu Handlung erforderlich, Geplant oder Verlauf, oder setzen Sie die Filter zurück, um die Ergebnisse zu erweitern.",
goToNeedsAction: "Zu „Handlung erforderlich“",
goToNeedsActionA11y: "Aufträge in „Handlung erforderlich“ anzeigen",
clearJobFiltersA11y: "Auftragsfilter zurücksetzen",
panelHeading: "Auftragsdetails",
emptyScopeTitle: "Keine Aufträge im Bereich",
emptyScopeSub: "Passen Sie Filter, Warteschlange oder Teambereich an, um Aufträge zu laden.",
sectionOverview: "Übersicht",
sectionActivity: "Aktivität",
noActivityYet: "Noch keine Aktivität.",
loading: "Aufträge werden geladen…",
emptyNoJobsYet: "Noch keine Aufträge",
emptyRecipientSub: "Aufträge aus mit Ihnen geteilten Prüfungen erscheinen hier, sobald der Prüfer sie aus genehmigten Reparaturen erstellt.",
emptyOwnerSub: "Erstellen Sie einen Auftrag direkt oder wandeln Sie genehmigte Reparaturen aus einer geteilten Prüfung um.",
viewActivity: "Aktivität anzeigen",
canonicalStatus: {
  skipped: "Übersprungen",
draft: "Entwurf",
open: "Offen",
accepted: "Angenommen",
scheduled: "Geplant",
in_progress: "In Bearbeitung",
paused: "Pausiert",
completed: "Abgeschlossen",
verified: "Abgezeichnet",
rejected: "Abgelehnt",
cancelled: "Abgebrochen",
},
fabCreateA11y: "Auftrag erstellen",
detailWorkPath: {
change: "Arbeitspfad ändern",
sheetTitle: "Arbeitspfad",
sheetHint: "Wählen Sie, wie dieser Auftrag ausgeführt wird: internes Team, ein Auftragnehmer oder Angebote anfordern.",
team: "Team",
contractor: "Auftragnehmer",
quotes: "Angebote",
},
},
inspectionDetail: {
firstRunMomentumHint: "Beantworten Sie jeden Punkt mit Bestanden, Nicht bestanden oder Entfällt. Tippen Sie bei allem, was einen Auftrag braucht, auf Nacharbeit.",
firstRunGotIt: "OK",
firstRunReportCta: "Problem melden",
reportIssueNow: "Problem jetzt melden",
completeInspection: "Prüfung abschließen",
completeShort: "Abschließen",
continueInspection: "Prüfung fortsetzen",
continueShort: "Fortsetzen",
manage: "Verwalten",
manageSheetTitle: "Prüfaktionen",
reassign: "Neu zuweisen",
pause: "Pausieren",
cancel: "Inspektion abbrechen…",
viewReport: "Bericht anzeigen",
nextSteps: "Nächste Schritte",
share: "Teilen",
createJobs: "Aufträge erstellen",
sendForApproval: "Zur Genehmigung senden",
shareReport: "Bericht teilen",
planFollowUp: "Folgeaktion planen",
planFollowUpHint: "Optionale Schritte nach Abschluss dieser Prüfung.",
saveTemplate: "Checkliste speichern",
repeatOnSchedule: "Nach Zeitplan wiederholen",
createJobNow: "Auftrag jetzt erstellen",
notifyTeam: "Team benachrichtigen",
moreMenuA11y: "Weitere Prüfaktionen",
},
assetDetail: {
  shareChooser: {
    intakeDescription: "Ohne Konto oder Anmeldung. Jede Meldung kommt unter Arbeit als Anfrage an, bereit für eine Prüfung oder einen Auftrag.",
    intakeTitle: "Jeder mit dem Code kann ein Problem melden",
    personDescription: "Sie sehen diese Anlage, ihre Prüfungen und Dokumente. Wählen Sie im nächsten Schritt Kann Arbeit anfordern, wenn sie auch Probleme melden sollen.",
    personTitle: "Mit einer Person oder einem Team teilen",
  },
  publicIntakeCard: {
    turnOff: "Deaktivieren",
    keepOn: "Aktiviert lassen",
    turnOffBody: "Gedruckte Codes und geteilte Links funktionieren erst wieder, wenn Sie es erneut aktivieren.",
    turnOffTitle: "Meldungen deaktivieren?",
    copyFailedBody: "Versuchen Sie es erneut. Sie können auch einen Screenshot des Codes teilen.",
    copyFailedTitle: "Link konnte nicht kopiert werden",
    linkCopied: "Link kopiert. Fügen Sie ihn dort ein, wo Probleme gemeldet werden sollen.",
    tryAgain: "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    updateFailedTitle: "Meldungen wurden nicht geändert",
    turnedOff: "Meldungen sind deaktiviert. Code und Link nehmen keine Meldungen mehr an.",
    turnedOn: "Meldungen sind aktiviert. Drucken Sie den Code oder kopieren Sie den Link und platzieren Sie ihn gut sichtbar.",
    printBody: "Scannen, um ein Problem zu melden. Kein Konto und keine Anmeldung nötig.",
    printTitle: "Problem melden — {{name}}",
    popupBlockedBody: "Erlauben Sie Pop-ups für diese Website zum Drucken, oder nutzen Sie Link kopieren.",
    popupBlockedTitle: "Pop-up blockiert",
    noWebAddress: "Meldungen sind aktiviert, aber diese App-Version kann den Link nicht erstellen. Öffnen Sie diese Anlage in AssetWRX im Webbrowser, um den Link zu kopieren oder den Code zu drucken.",
    copyLinkA11y: "Link zum Melden eines Problems kopieren",
    step3: "3. Sie beschreiben das Problem. Es erscheint unter Arbeit als Anfrage, die Sie prüfen.",
    qrLabel: "Code zum Melden eines Problems",
    title: "Jeder kann ein Problem melden",
  },
overviewInspectionEmpty: "Noch keine Prüfungen. Nutzen Sie",
startInspection: "Prüfung starten",
createJob: "Auftrag erstellen",
edit: "Bearbeiten",
contactsSectionTitle: "Verknüpfte Kontakte",
viewActivity: "Aktivität anzeigen",
toolsAi: "Werkzeuge & KI",
generateAdvancedReport: "Asset 360",
askAi: "KI fragen",
suggestNextSteps: "Nächste Schritte vorschlagen",
shareThisAssetModalTitle: "Diese Anlage teilen",
shareThisAssetAccessOnlySubtitle: "Geben Sie einer Person oder einem Team Zugriff auf den Datensatz, die Inspektionen und die Dokumente dieser Anlage.",
shareWithPersonAccessOnlyDescription: "Sie sehen den Datensatz, die Inspektionen und die Dokumente dieser Anlage.",
linkContactModalTitle: "Kontakt verknüpfen",
shareWithContactCallout: "Diese Anlage mit {{name}} teilen",
journey: {
title: "Betriebsverlauf",
stage: {
created: "Erstellt",
inspected: "Prüfungen abgeschlossen",
issues: "Probleme erfasst",
requests: "Anfragen gestellt",
jobs: "Aufträge abgeschlossen",
reports: "Berichte generiert",
},
window: {
"30d": "30 T.",
"90d": "90 T.",
"365d": "1 Jahr",
all: "Alle",
},
windowLabel: {
"30d": "In den letzten 30 Tagen",
"90d": "In den letzten 90 Tagen",
"365d": "In den letzten 12 Monaten",
all: "Über die gesamte Historie dieser Anlage",
},
readOnlyHint: "Sie haben nur Lesezugriff auf den Verlauf dieser Anlage.",
a11ySummaryLabel: "Zusammenfassung des Betriebsverlaufs",
a11yStageHint: "{{label}}: {{count}} im Zeitraum",
a11yStageSubline: "{{label}}: {{count}} im Zeitraum, {{subline}}",
zeroInWindow: "0 in {{window}}",
dateUnavailable: "Datum nicht verfügbar",
ago: {
minutes: "vor {{n}} Min.",
hours: "vor {{n}} Std.",
days: "vor {{n}} T.",
months_one: "vor {{count}} Mon.",
months_other: "vor {{count}} Mon.",
years_one: "vor {{count}} J.",
years_other: "vor {{count}} J.",
},
in: {
minutes: "in {{n}} Min.",
hours: "in {{n}} Std.",
days: "in {{n}} T.",
},
sublineIssueBreach: "{{days}}+ T. ohne Anfrage",
sublineAwaitingApproval_one: "{{count}} wartet auf Freigabe",
sublineAwaitingApproval_other: "{{count}} warten auf Freigabe",
summary: {
noActivity: "{{window}} gab es für diese Anlage keine erfasste Aktivität.",
recommendBaseline: "Wir empfehlen, eine Erstinspektion zu planen.",
hadBoth: "{{window}} hatte diese Anlage {{inspections}} und {{jobs}}.",
hadOne: "{{window}} hatte diese Anlage {{what}}.",
hadNone: "{{window}} wurde an dieser Anlage noch keine Arbeit abgeschlossen.",
inspections_one: "{{count}} Inspektion",
inspections_other: "{{count}} Inspektionen",
jobsCompleted_one: "{{count}} abgeschlossenen Auftrag",
jobsCompleted_other: "{{count}} abgeschlossene Aufträge",
healthImproved: "Der Betriebszustand stieg von {{then}}/100 auf {{now}}/100.",
healthDeclined: "Der Betriebszustand sank von {{then}}/100 auf {{now}}/100.",
healthCurrent: "Der aktuelle Betriebszustand liegt bei {{now}}/100, basierend auf Konformität, Zeitplänen, Aufträgen, Freigaben und Inspektionsbefunden.",
conditionUnscored_one: "Der Inspektionszustand ist nicht bewertet: {{count}} abgeschlossene Inspektion hat keine gültige Bewertung von 1–5.",
conditionUnscored_other: "Der Inspektionszustand ist nicht bewertet: keine der {{count}} abgeschlossenen Inspektionen hat eine gültige Bewertung von 1–5.",
conditionOneRated: "Für den Inspektionszustand gibt es eine bewertete Inspektion; für einen Verlauf ist eine weitere nötig.",
issueOverdue: "Für ein offenes Problem ist eine Anfrage überfällig.",
requestsAwaiting_one: "Eine Anfrage wartet auf Freigabe.",
requestsAwaiting_other: "{{count}} Anfragen warten auf Freigabe.",
excluded_one: "{{count}} abgeschlossene Inspektion wurde ausgeschlossen: {{reasons}}.",
excluded_other: "{{count}} abgeschlossene Inspektionen wurden ausgeschlossen: {{reasons}}.",
excludedMissing: "{{n}} ohne Abschlussdatum",
excludedInvalid: "{{n}} mit ungültigem Abschlussdatum",
excludedFuture: "{{n}} mit Datum in der Zukunft",
},
},
},
quickComplete: {
moreOptions: "Erweiterter Abschlussassistent",
moreOptionsA11y: "Erweiterten Abschlussassistenten öffnen",
eyebrow: "Schnellabschluss",
needsMore: {
  invoice: "Für diesen Auftrag fehlen noch Kosten und Rechnung. Weiter fügt sie hinzu und schließt ihn dann ab.",
  meter: "Für diesen Auftrag fehlt noch ein Zählerstand. Weiter fragt ihn ab und schließt den Auftrag dann ab.",
  checks: "Vor dem Abschluss muss noch etwas geklärt werden. Weiter zeigt, was.",
},
onePageTitle: "Auftrag abschließen",
continue: "Weiter",
submit: "Auftrag abschließen",
step1: {
title: "Kurznotiz",
noteLabel: "Was haben Sie gemacht?",
notePlaceholder: "Eine Zeile — repariert, ersetzt, geprüft, gereinigt.",
noteA11y: "Schnellabschluss-Notiz",
dictateStart: "Diktieren",
dictateStop: "Diktat beenden",
chipsLabel: "Oder tippen Sie auf ein Schnell-Tag",
},
step2: {
title: "Nachweis hinzufügen",
summary: "Machen Sie ein Foto oder fügen Sie ein Dokument bei. Optional, aber empfohlen.",
unavailable: "Nachweise können hier nicht direkt hinzugefügt werden.",
},
step3: {
title: "Einreichen",
summary: "Bestätigen und abschließen.",
note: "Notiz",
noNote: "Keine Notiz hinzugefügt",
tags: "Tags",
evidence: "Nachweis",
outcome: "Ergebnis",
},
},
changeRequest: {
comeBack: {
  title: "Ich muss wiederkommen",
  hint: "Ein weiterer Besuch an einem anderen Tag. Der Auftrag bleibt offen und wird einmal am Ende abgeschlossen.",
},
open: "Kann nicht wie geplant abgeschlossen werden",
openA11y: "Melden, dass dies nicht wie geplant abgeschlossen werden kann",
eyebrow: "Änderung angefordert",
step1: {
title: "Was hat Sie aufgehalten?",
summary: "Wählen Sie den passendsten Grund. Er entscheidet, wer informiert werden muss.",
},
step2: {
  datePlaceholder: "Tag wählen",
title: "Was brauchen Sie?",
summary: "Ihr Manager entscheidet. Nichts ändert sich, bis er das tut.",
summaryImmediate: "Das Überspringen wird sofort auf diesen Plan angewendet. Der Rest geht an Ihren Manager.",
dateLabel: "Verschieben auf",
assigneeLabel: "Jemanden vorschlagen",
assigneeHint: "Ein Vorschlag — Ihr Manager kann jemand anderen wählen.",
},
step3: {
title: "Noch etwas?",
noteLabel: "Details hinzufügen",
notePlaceholder: "Was Sie gesehen haben, mit wem Sie gesprochen haben, was weiterhelfen würde.",
evidencePrompt: "Ein Foto macht die Genehmigung deutlich einfacher.",
submit: "Anfrage senden",
submitImmediate: "Diese überspringen",
submitting: "Wird gesendet…",
},
reason: {
no_access: "Kein Zugang",
asset_unavailable: "Anlage nicht verfügbar",
asset_in_use: "Anlage in Benutzung",
unsafe: "Nicht sicher fortzufahren",
parts_unavailable: "Teile nicht verfügbar",
time_insufficient: "Nicht genug Zeit",
meter_inaccessible: "Zähler nicht erreichbar",
specialist_required: "Spezialist erforderlich",
wrong_assignee: "Sollte jemand anderes sein",
done_elsewhere: "Bereits anderswo erledigt",
not_required: "Nicht erforderlich",
bigger_than_described: "Größer als beschrieben",
other: "Etwas anderes",
},
action: {
reschedule: "Verschieben",
rescheduleBlurb: "Gleiche Arbeit, gleiche Person, ein späteres Datum.",
rescope: "Braucht mehr als beschrieben",
rescopeBlurb: "Gleiche Arbeit, gleiche Person, aber größer als beschrieben. Sagen Sie, wie lange sie wirklich braucht.",
rescopeLength: "Wie lange braucht sie wirklich? (Minuten)",
reassign: "Jemand anderes",
reassignBlurb: "Gleiche Arbeit, weiterhin fällig, eine andere Person.",
skip: "Diese überspringen",
skipBlurb: "Dieser Termin wird nicht erledigt. Der nächste bleibt fällig.",
},
status: {
  waitingOnApprover: "Wartet auf die Entscheidung der Person, die diese Anlage genehmigt. Sie erhalten eine Benachrichtigung.",
pending: "Änderung angefordert",
waitingOn: "Wartet auf die Entscheidung von {{name}}. Sie erhalten eine Benachrichtigung.",
approved: "Änderung genehmigt",
rejected: "Änderung nicht genehmigt",
stillDue: "Diese Arbeit ist weiterhin fällig",
},
review: {
  closeStale: "Anfrage schließen",
  changedSinceDecide: "Diese Arbeit hat sich nach dem Senden der Anfrage geändert und kann nicht mehr genehmigt werden. Schließen Sie sie mit einer Notiz; bei Bedarf kann erneut angefragt werden.",
title: "Anfrage prüfen",
requestedBy: "Angefordert von {{name}}",
asked: "Angefordert",
reason: "Grund",
evidence: "Nachweis",
current: "Aktuell",
proposed: "Vorgeschlagen",
changedSince: "Diese Arbeit hat sich geändert, seit die Anfrage gestellt wurde.",
approve: "Genehmigen",
reject: "Ablehnen",
editAndApprove: "Ändern und genehmigen",
rejectNeedsNote: "Begründen Sie die Ablehnung",
changeDate: "Ein anderes Datum genehmigen",
changeAssignee: "Jemand anderen genehmigen",
note: "Notiz hinzufügen",
complianceWarning: "Diese Anlage unterliegt einer Konformitätspflicht.",
},
},
completeWizard: {
needs: {
  title: "Prüfungen und Nachweise",
  summary: "Checkliste abhaken und Fotos hinzufügen. Die Fotos werden für Sie mit dem Auftrag abgeglichen.",
},
eyebrow: "Auftrag abschließen",
addCosts: "Kosten & Rechnung hinzufügen",
submit: "Abschluss einreichen",
step1: {
title: "Notizen",
noteLabel: "Was haben Sie gemacht?",
notePlaceholder: "Kurze Zusammenfassung — was Sie repariert, ersetzt oder geprüft haben.",
noteA11y: "Abschlussnotiz",
chipsLabel: "Schnell-Tags",
dictate: "Diktieren",
dictateStart: "Diktieren",
dictateStop: "Diktat beenden",
improve: "Mit KI überarbeiten",
improving: "Wird überarbeitet…",
},
step2: {
title: "Nachweis",
summary: "Fügen Sie einen Nachweis der Arbeit hinzu. Fotos, Dokumente oder bei Bedarf eine Rechnung.",
addPhoto: "Foto hinzufügen",
addDocument: "Dokument hinzufügen",
addInvoice: "Rechnung hinzufügen",
count_one: "{{count}} Element angehängt",
count_other: "{{count}} Elemente angehängt",
empty: "Noch kein Nachweis angehängt.",
analyze: "Fotos auslesen",
addToNote: "Extrahierten Text zur Notiz hinzufügen",
},
step3: {
title: "Kosten & Rechnung",
summary: "Erfassen Sie, was dieser Auftrag gekostet hat. Fügen Sie eine Rechnung oder Quittung hinzu, falls vorhanden.",
summaryInvoice: "Erfassen Sie, was dieser Auftrag gekostet hat, und fügen Sie eine Rechnung bei. Dieser Kunde verlangt eine.",
empty: "Hier ist kein Kosteneditor verfügbar. Erfassen Sie Kosten in der Verwaltungsansicht.",
},
step4: {
title: "Ergebnis",
summary: "Wie endete dieser Auftrag?",
followUpHint: "Wir bieten nach dem Einreichen an, einen Folgeauftrag zu erstellen.",
},
step5: {
title: "Prüfen und einreichen",
summary: "Bestätigen Sie, was eingereicht wird.",
note: "Notiz",
noNote: "Keine Notiz hinzugefügt",
tags: "Tags",
evidence: "Nachweis",
outcome: "Ergebnis",
cost: "Kosten",
noCost: "Nicht erfasst",
invoice: "Rechnung",
invoiceNone: "Keine",
evidenceNone: "Keine",
blockersTitle: "Vor dem Einreichen beheben:",
invoiceAttached: "{{n}} beigefügt",
invoiceRequiredMissing: "Erforderlich — keine beigefügt",
invoiceRequiredBlocker: "Dieser Kunde verlangt eine Rechnung. Fügen Sie unter Kosten & Rechnung eine bei oder erstellen Sie sie dort.",
},
chips: {
fixed: "Repariert",
replaced: "Ersetzt",
inspected: "Geprüft",
cleaned: "Gereinigt",
needsFollowUp: "Braucht Folgeaktion",
unableToComplete: "Nicht abschließbar",
},
outcomes: {
completed: "Abgeschlossen",
partial: "Teilweise abgeschlossen",
followUp: "Braucht Folgeaktion",
unable: "Nicht abschließbar",
},
step0: {
title: "Nachprüfung",
done: "Alle Prüfungen sind abgeschlossen. Fahren Sie fort, um den Auftrag abzuschließen.",
summary: "Beantworten Sie jeden Schritt der Nachprüfung. Der Auftrag kann erst eingereicht werden, wenn sie abgeschlossen ist.",
},
},
jobMode: {
switcher: {
enterFocus: "Fokusmodus",
exitFocus: "Ganzer Auftrag",
a11yEnterFocus: "Auf die Ausführung fokussieren – Verwaltungsdetails ausblenden",
a11yExitFocus: "Vollständigen Auftragsbereich anzeigen",
},
report: {
open: "Abschlussbericht öffnen",
title: "Abschlussbericht",
fallbackTitle: "Auftrag",
missingJob: "Arbeitsauftrag nicht gefunden.",
followOn: "Folgearbeit",
shareTitle: "Abschlussbericht teilen",
shareAction: "Teilen",
shareReviewLink: "Prüflink teilen",
shareSheetTitle: "Bericht teilen",
summaryEyebrow: "Abschlusszusammenfassung",
notesEyebrow: "Abschlussnotizen",
noNotes: "—",
checksEyebrow: "Vor- und Nachprüfungen",
evidenceEyebrow: "Nachweise und Anhänge",
recentExports: "Aktuelle Exporte",
optionsTitle: "Berichtsoptionen",
fields: {
job: "Auftrag",
jobType: "Auftragsart",
parentJob: "Übergeordneter Arbeitsauftrag",
asset: "Anlage",
location: "Standort",
assignedTo: "Zugewiesen an",
status: "Status",
submitted: "Eingereicht",
verified: "Verifiziert",
completed: "Abgeschlossen",
actualCost: "Tatsächliche Kosten",
},
},
},
maintenance: {
  steps: {
    keep: "Schritte behalten",
    close: "Schließen",
    failed: "Die Schritte konnten nicht gespeichert werden",
    unlinked: "Verknüpfung aufgehoben. Jeder Schritt ist wieder ein eigener Plan.",
    unlinkConfirm: "Aufheben",
    unlinkMessage: "Jeder Schritt wird wieder ein eigener Plan und behält seinen Zeitplan. Nichts wird gelöscht.",
    unlinkTitle: "Verknüpfung dieser Schritte aufheben?",
    unlink: "Verknüpfung aufheben",
    saved: "Schritte gespeichert.",
    save: "Schritte speichern",
    inOrderOff: "Jeder Schritt kommt nach seinem eigenen Zeitplan.",
    inOrderOn: "Die Arbeit eines Schritts wird erst angelegt, wenn der Schritt davor keine offene Arbeit mehr hat.",
    inOrderTitle: "Schritte in Reihenfolge erledigen",
    moveDownA11y: "{{name}} nach unten verschieben",
    moveUpA11y: "{{name}} nach oben verschieben",
    removeA11y: "{{name}} aus den Schritten entfernen",
    addA11y: "{{name}} als Schritt hinzufügen",
    add: "Hinzufügen",
    inOtherSet: "Derzeit ein Schritt von {{name}}",
    otherLabel: "Weitere Pläne dieser Anlage",
    needTwo: "Fügen Sie mindestens zwei Pläne aus der Liste unten hinzu.",
    stepsLabel: "Schritte in Reihenfolge",
    namePlaceholder: "Zum Beispiel: Generatorwartung",
    nameLabel: "Name",
    intro: "Schritte sind Pläne, die zusammengehören, etwa eine Wartung nach 500, 1.000 und 2.000 Stunden.",
    titleEdit: "Schritte bearbeiten",
    titleNew: "Pläne als Schritte verknüpfen",
    addStep: "Schritt hinzufügen",
    editSteps: "Schritte bearbeiten",
    linkSteps: "Pläne als Schritte verknüpfen",
  },
  list: {
    status: {
      cancelled: "Abgebrochen",
      ended: "Beendet",
      paused: "Pausiert",
      active: "Aktiv",
    },
    openJobA11y: "Aktuellen Auftrag für {{name}} öffnen",
    editA11y: "{{name}} bearbeiten",
    untitled: "Plan ohne Titel",
    groupA11y: "{{asset}}: {{n}} Pläne. Öffnet die Anlage.",
    emptyBody: "Fügen Sie einen Plan für wiederkehrende Arbeit hinzu – eine monatliche Wartung, eine jährliche Prüfung. Bei jeder Fälligkeit erscheint der Auftrag unter Arbeit.",
    tryAgain: "Erneut versuchen",
    loadFailed: "Wartungspläne konnten nicht geladen werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    activeMany: "{{live}} Pläne laufen",
    activeOne: "1 Plan läuft",
    noneActive: "Kein Plan läuft. Setzen Sie einen fort oder fügen Sie einen neuen hinzu.",
    dueInDays: "Nächste Fälligkeit in {{days}} Tagen",
    dueTomorrow: "Nächste Fälligkeit morgen",
    dueToday: "Nächste Fälligkeit heute",
    overdueDays: "{{days}} Tage überfällig",
    overdueOneDay: "1 Tag überfällig",
    doneCount: "{{done}} ausgelöst",
    doneOfMax: "{{done}} von {{max}} ausgelöst",
  },
  cadence: {
    fromLastDone: "{{cadence}}, gezählt ab Erledigung des letzten",
    oneOff: "Einmalig",
    either: "{{first}} oder {{second}} – je nachdem, was zuerst eintritt",
    everyAmount: "Alle {{amount}}",
    everyNYears_one: "Im Abstand von {{count}} Jahr",
    everyNYears_other: "Alle {{count}} Jahre",
    everyYear: "Jedes Jahr",
    everyNMonths_one: "Im Abstand von {{count}} Monat",
    everyNMonths_other: "Alle {{count}} Monate",
    everyMonth: "Jeden Monat",
    everyNWeeks_one: "Im Abstand von {{count}} Woche",
    everyNWeeks_other: "Alle {{count}} Wochen",
    everyWeek: "Jede Woche",
    everyNDays_one: "Im Abstand von {{count}} Tag",
    everyNDays_other: "Alle {{count}} Tage",
    everyDay: "Jeden Tag",
    everyNHours_one: "Im Abstand von {{count}} Stunde",
    everyNHours_other: "Alle {{count}} Stunden",
    everyHour: "Jede Stunde",
  },
title: "Wartung",
recordReading: "Zählerstand erfassen",
addPlan: "Plan hinzufügen",
startNow: "Jetzt starten",
exceptions: {
lead: "Die meisten Überspringungen sind „{{reason}}“ — {{share}} % davon.",
counts: "{{skipped}} übersprungen · {{missed}} verpasst",
emptyDimension: "Dazu ist noch nichts erfasst — versuchen Sie eine andere Aufschlüsselung.",
noSite: "Kein Standort",
unassigned: "Nicht zugewiesen",
by: {
reason: "Grund",
asset: "Anlage",
site: "Standort",
assignee: "Zuständige Person",
programme: "Wartungsplan",
team: "Team",
},
},
card: {
  ok: "OK",
  actionFailedBody: "Es wurde nichts geändert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  allPlans: "Alle Pläne",
heading: "Wartungspläne",
attention_one: "{{count}} Plan braucht Aufmerksamkeit",
attention_other: "{{count}} Pläne brauchen Aufmerksamkeit",
allOnTrack: "Alle Pläne sind im Zeitplan",
pausedCount_one: "{{count}} Plan pausiert",
pausedCount_other: "{{count}} Pläne pausiert",
nextUp: "Als Nächstes: {{what}}",
showAll: "Alle {{count}} Pläne anzeigen",
showFewer: "Weniger anzeigen",
expandHint: "Zeigt anstehende Termine und Planaktionen",
status: {
job_overdue: "Auftrag offen · überfällig",
overdue: "Überfällig",
job_due: "Auftrag offen · jetzt fällig",
due: "Jetzt fällig",
no_reading: "Braucht einen Zählerstand",
due_soon: "Bald fällig",
due_soon_days_one: "Morgen fällig",
due_soon_days_other: "Fällig in {{count}} Tagen",
due_soon_amount: "Fällig in {{amount}}",
job: "Auftrag offen",
waits: "Wartet auf {{stage}}",
waits_generic: "Wartet auf den vorherigen Schritt",
afterStep: "Nach Schritt {{n}}",
skipped: "Diesmal übersprungen",
upcoming_date: "Nächster Termin {{when}}",
upcoming_time: "Nächster Termin um {{time}}",
upcoming_meter: "Nächster Termin bei {{amount}}",
upcoming_none: "Läuft bei Start",
upcoming_condition: "Zustand wird beobachtet",
paused: "Pausiert",
},
cadence: {
manual: "Wenn jemand ihn startet",
fixedDate: "Einmalig, am {{when}}",
fixedDates_one: "An {{count}} festen Termin",
fixedDates_other: "An {{count}} festen Terminen",
condition: "Wenn der Zustand auf {{score}} oder darunter fällt",
renewal: "Wenn das zugehörige Dokument zur Verlängerung fällig ist",
byMeter: {
operating_hours: "Nach Betriebsstunden",
mileage: "Nach Kilometerstand",
cycles: "Nach Zyklen",
custom_numeric: "Nach Zählerstand",
electricity: "Nach Stromzähler",
gas: "Nach Gaszähler",
water: "Nach Wasserzähler",
heat: "Nach Wärmezähler",
oil: "Nach Ölzähler",
},
},
comingUp: "Anstehend",
lastDone: "Zuletzt erledigt",
notDoneYet: "Noch nicht erledigt",
perDay: "danach {{count}} pro Tag",
jobOpen: "Auftrag offen",
either: "{{amount}} oder {{when}}, je nachdem, was zuerst eintritt",
nothingNext: "Nichts ist geplant. Er läuft, wenn jemand ihn startet.",
nothingNextCondition: "Arbeit wird erzeugt, wenn der Zustandswert so weit fällt.",
pausedNext: "Solange der Plan pausiert ist, wird nichts erstellt.",
steps_sequential_one: "{{count}} Schritt, in Reihenfolge erledigt",
steps_sequential_other: "{{count}} Schritte, in Reihenfolge erledigt",
steps_independent_one: "{{count}} Plan in dieser Gruppe",
steps_independent_other: "{{count}} Pläne in dieser Gruppe",
step: "Schritt {{n}}",
openJob: "Auftrag öffnen",
startNow: "Jetzt starten",
edit: "Bearbeiten",
bringForward: "Vorziehen",
endStep: "Schritt beenden",
pause: "Pausieren",
resume: "Fortsetzen",
end: "Plan beenden",
endTitle: "Diesen Plan beenden?",
endMessage: "Es wird keine neue Arbeit erstellt. Bereits erstellte Arbeit bleibt in Arbeit, und ihr Verlauf bleibt an der Anlage.",
keep: "Plan beibehalten",
actionFailed: "Der Plan konnte nicht geändert werden",
},
startFailedTitle: "Konnte nicht gestartet werden",
noReading: "Noch kein Zählerstand.",
noPlans: "Noch kein Wartungsplan.",
plansHeading: "Pläne · {{n}}",
plansHeadingNone: "Pläne",
meters: {
heading: "Zähler · {{n}}",
since: "{{amount}} seit {{when}}",
record: "Zählerstand erfassen",
},
emptyReadingTitle: "Kein Zählerstand erfasst",
emptyReadingBody: "Pläne, die nach Nutzung zählen, brauchen einen Ausgangswert.",
emptyPlansTitle: "Noch keine Pläne",
emptyPlansBody: "Tippen Sie auf „Plan hinzufügen“ für Arbeit, die wiederkommt – eine Wartung, eine Prüfung oder eine Inspektion. Jede erscheint bei Fälligkeit unter Arbeit.",
kind: {
mileage: "Kilometerstand",
operating_hours: "Stunden",
cycles: "Zyklen",
electricity: "Strom",
gas: "Erdgas",
water: "Wasser",
heat: "Wärme",
oil: "Heizöl",
custom_numeric: "Sonstiger",
},
unit: {
mi: "mi",
km: "km",
h: "h",
cycles: "Zyklen",
},
source: {
manual: "eingegeben",
local_ml: "aus Foto",
imported: "importiert",
api: "API",
iot: "Sensor",
},
sync: {
pending: "Auf diesem Gerät gespeichert — wird synchronisiert, sobald online.",
failed: "Konnte nicht gespeichert werden — es wurde zuerst ein höherer Wert erfasst.",
},
rowTitle: {
due_soon_meter: "{{title}} fällig in {{amount}}",
due_meter: "{{title}} jetzt fällig",
overdue_meter: "{{title}} überfällig um {{amount}}",
due_soon_calendar: "{{title}} bald fällig",
due_calendar: "{{title}} heute fällig",
overdue_calendar: "{{title}} überfällig",
},
sheet: {
  typeReading: "Geben Sie den Zählerstand ein. Ein Foto wird als Nachweis gespeichert; die Handy-App kann die Zahl daraus lesen.",
  kind: "Zähler",
  noMeterId: "Ohne Zähler-ID",
  newMeter: "Neuer Zähler",
  meterId: "Zähler-ID (optional)",
  meterIdPlaceholder: "Seriennummer oder Zählpunkt",
  unit: "Einheit",
title: "Zählerstand erfassen",
close: "Schließen",
value: "Zählerstand",
when: "Erfasst am",
whenInvalid: "Wählen Sie ein gültiges Datum und eine gültige Uhrzeit.",
currentIs: "Aktuell: {{amount}} · {{when}}",
reading: "Foto wird auf diesem Gerät gelesen…",
detected: "Erkannter Zählerstand: {{amount}}",
trust: {
confirm: "Bestätigen · auf diesem Gerät gelesen, keine KI-Credits verwendet",
check: "Prüfen · auf diesem Gerät gelesen, keine KI-Credits verwendet",
},
use: "Verwenden",
ignore: "Ignorieren",
nothingDetected: "Kein Zählerstand im Foto gefunden — geben Sie ihn manuell ein. Das Foto wird als Nachweis behalten.",
lower: "Dies ist niedriger als der aktuelle Wert {{amount}}.",
outOfOrder: "Ein Zählerstand von {{amount}} ist bereits nach diesem Datum erfasst. Prüfen Sie, wann dieser aufgenommen wurde.",
lowerAsk: "Als Korrektur erfassen? Der frühere Wert bleibt im Verlauf, zählt aber nicht mehr.",
lowerHint: "Prüfen Sie den Wert, oder bitten Sie einen Manager, eine Korrektur zu erfassen.",
correctionNote: "Warum ist der frühere Wert falsch?",
correctionNoteRequired: "Geben Sie an, warum der frühere Wert falsch war.",
unitMismatch: "Dieser Zähler misst in {{unit}}.",
save: "Zählerstand speichern",
saveCorrection: "Als Korrektur speichern",
saving: "Wird gespeichert…",
failed: "Der Zählerstand konnte nicht gespeichert werden.",
savedOfflineTitle: "Auf diesem Gerät gespeichert",
savedOffline: "Wird synchronisiert, sobald Sie wieder online sind.",
recent: "Letzte Zählerstände",
correctionTag: "Korrektur",
},
},
contractor: {
title: "Meine Arbeit",
view: {
new: "Neu",
upcoming: "Zu erledigen",
in_progress: "In Arbeit",
awaiting_review: "Wartet",
complete: "Erledigt",
},
empty: {
new: "Derzeit keine neuen Anfragen",
upcoming: "Nichts geplant",
in_progress: "Nichts in Arbeit",
awaiting_review: "Nichts beim Kunden",
complete: "Noch nichts abgeschlossen",
},
emptyHint: {
new: "Einladungen und Angebotsanfragen erscheinen hier.",
upcoming: "Angenommene Aufträge erscheinen hier.",
in_progress: "Starten Sie einen Auftrag aus Anstehend, wenn Sie vor Ort sind.",
awaiting_review: "Eingereichte Arbeit wartet hier auf die Freigabe.",
complete: "Vom Kunden freigegebene Arbeit erscheint hier.",
},
quoteFallbackTitle: "Angebotsanfrage",
clientOther: "Sonstige",
next: {
quote: "Preis senden oder ablehnen",
waitingClient: "Wartet auf den Kunden",
},
notLinked: {
title: "Noch nicht als Auftragnehmer eingerichtet",
body: "Bitten Sie Ihren Kunden, Sie mit der E-Mail-Adresse hinzuzufügen, mit der Sie sich registriert haben. Dann erscheint die Arbeit hier.",
bodyWithEmail: "Bitten Sie Ihren Kunden, Sie mit {{email}} als Auftragnehmer hinzuzufügen. Seine Aufträge und Angebotsanfragen erscheinen dann hier.",
checkAgain: "Erneut prüfen",
checking: "Wird geprüft…",
},
loadFailed: {
title: "Ihre Arbeit wurde nicht geladen",
body: "Prüfen Sie Ihre Verbindung und tippen Sie dann auf Erneut versuchen.",
retry: "Erneut versuchen",
},
},
planning: {
  lockedHint: "Verteilen Sie Besuche auf Personen und Zeiten, sehen Sie die Fahrzeit und lassen Sie sich einen Plan für den Tag vorschlagen.",
  leave: {
    message_other: "Sie haben {{count}} Planänderungen, die noch nicht gespeichert sind. Verwerfen Sie sie, oder planen Sie weiter und tippen Sie auf Anwenden.",
    message_one: "Sie haben {{count}} Planänderung, die noch nicht gespeichert ist. Verwerfen Sie sie, oder planen Sie weiter und tippen Sie auf Anwenden.",
    discard: "Änderungen verwerfen",
    keep: "Weiter planen",
    title: "Verlassen, ohne den Plan zu speichern?",
  },
range: {
day: "Tag",
threeDay: "3 Tage",
week: "Woche",
month: "Monat",
agenda: "2 Wochen",
a11y: "Kalenderbereich",
},
nav: {
previousA11y: "Früher",
nextA11y: "Später",
today: "Heute",
todayA11y: "Zu heute springen",
},
lane: {
unassigned: "Nicht zugewiesen",
you: "Sie",
unnamed: "Unbenannte Person",
notWorking: "Arbeitet nicht",
timeOff: "Abwesend",
more: "+{{count}} weitere",
moreA11y: "{{count}} weitere um {{time}} anzeigen",
showLess: "Weniger anzeigen",
load: "{{percent}} % verplant · {{work}}",
capacityA11y: "{{name}}: {{percent}} % des Tages sind verplant",
},
summary: {
jobs_one: "{{count}} Einsatz",
jobs_other: "{{count}} Einsätze",
work: "{{duration}} Arbeit",
travel: "{{duration}} Fahrt",
travelEstimated: "ca. {{duration}} Fahrt",
travelUnknown_one: "{{count}} Fahrt ohne Standort",
travelUnknown_other: "{{count}} Fahrten ohne Standort",
free: "{{duration}} frei",
overtime: "{{duration}} Überstunden",
},
readiness: {
ready: "Bereit {{count}}",
parts: "Teile fehlen {{count}}",
capacity: "Niemand frei oder qualifiziert {{count}}",
other: "Wartend {{count}}",
defer: "Kann warten {{count}}",
},
unplanned: {
nobody: "Hat eine Zeit, aber niemanden",
title: "Ungeplant · {{count}}",
empty: "Alles in dieser Ansicht ist geplant.",
filterDue: "Fällig",
filterAll: "Alle",
filterA11y: "Welche ungeplante Arbeit angezeigt wird",
due: "Fällig {{date}}",
overdue: "Überfällig",
},
reason: {
parts_unavailable: "Teil nicht verfügbar",
technician_unavailable: "Niemand verfügbar",
skill_missing: "Qualifikation nicht verfügbar",
dependency: "Wartet auf andere Arbeit",
no_capacity: "Keine Kapazität",
location_missing: "Kein Standort",
appointment_conflict: "Termin nicht einhaltbar",
outside_hours: "Außerhalb der Arbeitszeit",
awaiting_approval: "Wartet auf Genehmigung",
declined: "Abgelehnt",
crew_unavailable: "Nicht genug Personen gleichzeitig frei",
},
signal: {
overlap: "Doppelt gebucht",
insufficient_travel: "Zu wenig Fahrzeit",
skill_missing: "Qualifikation fehlt",
parts_unavailable: "Teil nicht verfügbar",
outside_appointment: "Außerhalb des Termins",
outside_hours: "Außerhalb der Arbeitszeit",
technician_unavailable: "Abwesend",
dependency_unmet: "Wartet auf andere Arbeit",
after_due: "Nach dem Fälligkeitsdatum",
urgent: "Hohe Priorität",
parts_ready: "Teile bereit",
parts_unknown: "Teile nicht bestätigt",
appointment: "Terminfenster",
awaiting_acceptance: "Wartet auf Annahme",
confirmed: "Bestätigt",
locked: "Feste Zeit",
duration_default: "Geschätzte Dauer",
duration_learned: "Übliche Dauer",
multi_day: "Über mehrere Tage",
crew_visit: "Als Teil des Teams",
via_pickup: "Teileabholung unterwegs",
},
state: {
pending: "Vorgeschlagen",
in_progress: "In Arbeit",
done: "Erledigt",
},
travel: {
block: "{{duration}} Fahrt · {{distance}}",
estimated: "ca. {{duration}} Fahrt · {{distance}}",
a11y: "Fahrt: {{duration}}",
estimateNote: "Die Fahrzeit ist aus der Luftlinie bei Stadtgeschwindigkeit geschätzt, ohne Verkehr. Tippen Sie auf eine Fahrt, um sie in Karten zu prüfen.",
roadNote: "Die Fahrzeit ist die übliche Straßenfahrzeit ohne Echtzeitverkehr. Tippen Sie auf eine Fahrt, um sie in Karten zu prüfen.",
short: "{{duration}} Fahrt",
shortEstimated: "ca. {{duration}} Fahrt",
},
week: {
legend: {
work: "Arbeit",
travel: "Fahrt",
free: "Frei",
overtime: "Außerhalb der Arbeitszeit",
},
openDayA11y: "{{day}} planen",
cellA11y: "{{name}}, {{day}}: {{percent}} % verplant, {{work}} Arbeit, {{travel}} Fahrt",
cellOffA11y: "{{name}}, {{day}}: arbeitet nicht",
percent: "{{percent}} %",
free: "Frei",
hoursUnknown: "Arbeitszeit unbekannt",
unplannedDue: "Ungeplant, fällig",
forecast: "Mit erwarteter Arbeit",
forecastOver: "{{duration}} zu viel",
forecastFits: "Passt",
},
panel: {
assignedTo: "Zugewiesen an",
nobody: "Noch niemand. Wählen Sie, wer das übernimmt.",
partArrives: "Falls das Teil eintrifft am",
planFromThen: "Ab dann einplanen",
makeRoom: "Platz schaffen",
makeRoomHint: "Das überschneidet sich mit einem anderen Einsatz. Bieten Sie diesem Einsatz einen neuen Platz an.",
day: "Tag",
start: "Beginn",
length: "Dauer",
ends: "Endet {{time}}",
notPlanned: "Nicht geplant",
moreNotes_one: "{{count}} weiterer Hinweis",
moreNotes_other: "{{count}} weitere Hinweise",
fewerNotes: "Weniger Hinweise",
staged: "Noch nicht gespeichert",
fixed: "Diese Arbeit hat begonnen oder ist bestätigt und bleibt daher, wo sie ist.",
awaitingApproval: "Wartet auf Freigabe. Kann noch nicht geplant werden.",
previousDayA11y: "Der Tag davor",
nextDayA11y: "Der Tag danach",
earlierA11y: "15 Minuten früher beginnen",
laterA11y: "15 Minuten später beginnen",
shorterA11y: "15 Minuten kürzer",
longerA11y: "15 Minuten länger",
remove: "Aus dem Plan nehmen",
pin: "Diese Zeit festlegen",
unpin: "Zeit freigeben",
undo: "Änderung zurücknehmen",
open: "Öffnen",
closeA11y: "Planbereich schließen",
},
apply: {
changes_one: "{{count}} Änderung nicht gespeichert",
changes_other: "{{count}} Änderungen nicht gespeichert",
notifies: "Beim Anwenden werden informiert: {{names}}",
discard: "Verwerfen",
apply: "Anwenden",
breaks: "Verstößt gegen eine Regel: {{rules}}",
reasonLabel: "Grund, trotzdem fortzufahren",
reload: "Neu laden",
done: "Plan gespeichert",
conflict: "Jemand anderes hat {{days}} geändert, während Sie geplant haben. Laden Sie neu, um es zu sehen. Ihre Änderungen bleiben erhalten.",
failed_one: "{{count}} Änderung konnte nicht gespeichert werden: {{message}}",
failed_other: "{{count}} Änderungen konnten nicht gespeichert werden. Die erste: {{message}}",
error: "Der Plan konnte nicht gespeichert werden. {{message}}",
partial: "{{applied}} von {{requested}} Änderungen übernommen",
none_one: "Die Änderung konnte nicht übernommen werden",
none_other: "Keine der {{count}} Änderungen konnte übernommen werden",
unsettled: "Die Änderungen wurden geschrieben, das Ergebnis konnte aber nicht bestätigt werden. Laden Sie neu, um den Plan zu prüfen.",
reviewIssues_one: "{{count}} Problem prüfen",
reviewIssues_other: "{{count}} Probleme prüfen",
issues: {
title: "Nicht übernommene Änderungen",
appliedLine_one: "{{count}} Änderung übernommen",
appliedLine_other: "{{count}} Änderungen übernommen",
retry: "Fehlgeschlagene erneut versuchen",
keep: "Übernommene behalten",
discardRest: "Übrige verwerfen",
open: "Öffnen",
closeA11y: "Prüfung der nicht übernommenen Änderungen schließen",
code: {
refused: "Nicht erlaubt",
not_persisted: "Nicht gespeichert",
unverified: "Speichern nicht bestätigt",
missing: "Existiert nicht mehr",
},
},
recover: "Eine frühere Planänderung wurde nicht abgeschlossen.",
recoverAction: "Prüfen",
recovered: {
applied: "Die frühere Änderung war vollständig übernommen.",
failed: "Von der früheren Änderung war nichts übernommen.",
},
stale: "Jemand hat {{days}} nach Ihren Änderungen geändert. Prüfen Sie die Tafel und behalten oder verwerfen Sie dann Ihre Änderungen.",
staleAction: "Meine Änderungen behalten",
overrideNote: "{{rule}}, übergangen: {{reason}}",
},
optimise: {
action: "Plan vorschlagen",
title: "Vorgeschlagener Plan",
whatIfA11y: "Was, wenn {{name}} ausfällt?",
whyShow: "Warum dieser Plan",
whyHide: "Gründe ausblenden",
scenarioOff: "Was wäre, wenn {{name}} frei hat",
scenarioArrival: "Was wäre, wenn das Teil am {{date}} ankommt",
scenarioNote: "Nur eine Vorschau. Nichts ändert sich, bis Sie auf Diesen Plan verwenden tippen.",
working: "Plan wird erstellt … {{seconds}} s",
stop: "Stoppen",
useScenario: "Diesen Plan verwenden",
closeA11y: "Vorgeschlagenen Plan schließen",
removeA11y: "{{title}} unverändert lassen",
why: {
placed: "Eingeplant wegen: {{list}}.",
held: "Weiterhin ungeplant: {{list}}.",
reason: "{{count}} × {{reason}}",
blocker: "{{count}} × {{reason}}",
join: " · ",
},
whyReason: {
required_skill: "erforderliche Qualifikation",
parts_ready: "Teile bereit",
due_today: "an dem Tag fällig",
urgent: "hohe Priorität",
near_previous: "nahe beim vorherigen Stopp",
same_site: "bereits am Standort",
keeps_assignee: "bleibt bei derselben Person",
saves_travel: "spart Fahrzeit",
after_overrun: "nach der Zeitüberschreitung",
from_position: "vom aktuellen Standort aus",
overtime: "über den Tag hinaus",
with_crew: "mit dem Team",
via_pickup: "über eine Abholung",
swapped: "zwischen Personen getauscht",
fits_capacity: "passt in den Tag",
},
extraPerson: "Was wäre mit einer Person mehr?",
extraPersonTakes_one: "Eine Person mehr würde {{count}} weiteren Einsatz übernehmen.",
extraPersonTakes_other: "Eine Person mehr würde {{count}} weitere Einsätze übernehmen.",
extraPersonNone: "Eine Person mehr würde den Plan nicht ändern.",
none: "Nichts zu verbessern: Der Plan passt bereits.",
planned: "Geplant {{before}} → {{after}}",
travel: "Fahrzeit {{before}} → {{after}}",
stillUnplanned_one: "{{count}} weiterhin ungeplant",
stillUnplanned_other: "{{count}} weiterhin ungeplant",
confidence: {
high: "Hohe Sicherheit",
medium: "Mittlere Sicherheit",
low: "Geringe Sicherheit",
},
note: {
parts_unknown_one: "Teile für {{count}} Einsatz nicht bestätigt",
parts_unknown_other: "Teile für {{count}} Einsätze nicht bestätigt",
location_missing_one: "{{count}} Einsatz hat keinen Standort",
location_missing_other: "{{count}} Einsätze haben keinen Standort",
duration_default_one: "{{count}} Einsatz nutzt eine geschätzte Dauer",
duration_default_other: "{{count}} Einsätze nutzen eine geschätzte Dauer",
travel_estimated_one: "Fahrzeit für {{count}} Fahrt geschätzt",
travel_estimated_other: "Fahrzeit für {{count}} Fahrten geschätzt",
},
reason: {
required_skill: "Hat die erforderliche Qualifikation",
parts_ready: "Teile bereit",
due_today: "An diesem Tag fällig",
urgent: "Hohe Priorität",
near_previous: "{{duration}} vom vorherigen Halt",
same_site: "Bereits an diesem Standort",
fits_capacity: "Passt in den Tag",
keeps_assignee: "Bleibt bei derselben Person",
saves_travel: "Spart {{duration}} Fahrzeit",
after_overrun: "Beginnt, wenn der Auftrag davor fertig sein kann",
from_position: "Beginnt, wenn die Person vom aktuellen Standort aus dort sein kann",
overtime: "{{duration}} über den Arbeitstag hinaus",
with_crew: "Zusammen mit dem Team zur selben Zeit eingeplant",
via_pickup: "Über die Teileabholung",
swapped: "Mit einer anderen Person getauscht, spart {{duration}}",
},
},
schedulePlan: {
save: "Plan speichern",
failed: "Speichern nicht möglich. {{message}}",
},
myDay: {
  boardHint: "Den Tag des ganzen Teams sehen Sie hier. Um Arbeit auf der Tagestafel zwischen Personen zu verschieben, öffnen Sie Arbeit auf einem Tablet oder Computer.",
  title: "Mein Tag",
saved: "Gespeichert {{time}} · keine Verbindung, letzte Kopie wird angezeigt",
savedWide: "Gespeichert {{time}} · Server nicht erreichbar, letzte Kopie wird angezeigt. Bis dahin kann nichts übernommen werden.",
changed: "Ihr Plan hat sich in der Zwischenzeit geändert: {{moved}} verschoben, {{added}} neu, {{removed}} entfernt.",
changedDismissA11y: "Hinweis zu den Änderungen schließen",
mine: "Mein Tag",
everyone: "Alle",
switchA11y: "Wessen Tag angezeigt wird",
accept: "Annehmen",
decline: "Ablehnen",
accepted: "Angenommen",
acceptFailed: "Annehmen nicht möglich. {{message}}",
startNext: "Als Nächstes starten: {{title}}",
},
insights: {
eyebrow: "Arbeitsplanung",
title: "Wie der Plan läuft",
subtitle: "Die letzten {{days}} Tage",
none: "—",
utilisation: "Arbeiten statt fahren",
utilisationCaption: "der geplanten Zeit",
utilisationInfo: "Arbeit als Anteil an Arbeit plus Fahrzeit über alle geplanten Tage im Zeitraum. Fahrzeit ist nie produktive Zeit.",
adherence: "Wie geplant begonnen",
adherenceCaption_one: "von {{count}} geplantem Einsatz",
adherenceCaption_other: "von {{count}} geplanten Einsätzen",
adherenceInfo: "Geplante Einsätze, die innerhalb von {{minutes}} Minuten nach geplantem Beginn begonnen haben.",
actual: "Tatsächliche vs. geplante Dauer",
actualCaption_one: "Median von {{count}} Einsatz",
actualCaption_other: "Median von {{count}} Einsätzen",
actualInfo: "Wie lange abgeschlossene Einsätze wirklich dauerten, als Anteil der geplanten Dauer. 100 % ist wie geplant; mehr heißt, die Pläne sind zu knapp.",
},
directions: {
action: "Route",
route: "Tagesroute",
routeA11y: "Route für {{name}} in Karten öffnen",
legA11y: "Öffnet diese Fahrt in Karten",
partsTitle: "Diese Route öffnet sich in Teilen",
partsBody: "Ein Kartenlink fasst nur eine begrenzte Zahl von Halten. Wählen Sie den Teil, der geöffnet werden soll.",
part: "Halte {{from}}–{{to}}",
cancel: "Abbrechen",
},
map: {
show: "Karte",
hide: "Tafel",
hideNarrow: "Liste",
empty: "Nichts, was an diesem Tag geplant ist, hat einen Standort.",
unplannedNearby_one: "{{count}} ungeplant, mit Standort",
unplannedNearby_other: "{{count}} ungeplant, mit Standort",
stopA11y: "Halt {{number}}: {{title}}",
noLocation_one: "{{count}} ohne Standort",
noLocation_other: "{{count}} ohne Standort",
legend: "Gestrichelte Linien verbinden die Halte in der Reihenfolge. Sie sind nicht die Straße.",
},
home: {
title: "Plan für heute",
count_one: "{{count}} Einsatz",
count_other: "{{count}} Einsätze",
withNext_one: "{{count}} Einsatz · als Nächstes {{time}} {{title}}",
withNext_other: "{{count}} Einsätze · als Nächstes {{time}} {{title}}",
},
settings: {
title: "Planungseinstellungen",
closeA11y: "Planungseinstellungen schließen",
week: "Arbeitswoche",
starts: "Tag beginnt",
ends: "Tag endet",
break: "Pause",
noBreak: "Keine",
defaults: "Wenn nichts angegeben ist",
jobLength: "Ein Auftrag dauert",
inspectionLength: "Eine Inspektion dauert",
citySpeed: "Fahren in der Stadt",
citySpeedHint: "Dient zur Schätzung der Fahrzeit, wenn keine Straßenzeit bekannt ist. Längere Fahrten gelten als schneller.",
save: "Speichern",
failed: "Speichern nicht möglich. {{message}}",
person: "Für {{name}}",
personHours: "Arbeitszeiten",
ownHours: "Eigene",
sameHours: "Wie der Arbeitsbereich",
personDepot: "Wo der Tag dieser Person beginnt und endet",
savePerson: "Für diese Person speichern",
overtime: "Vorgeschlagene Pläne dürfen den Tag überschreiten um",
noOvertime: "Nie",
overtimeHint: "Vorgeschlagene Pläne vermeiden das, wo sie können. Eine Änderung über den Tag hinaus wird markiert und braucht vor dem Anwenden eine Begründung.",
depot: "Wo der Tag beginnt und endet",
noDepot: "Nicht gesetzt",
depotHint: "Ein Standort. Die erste und letzte Fahrt des Tages zählen von hier.",
usePositions: "Standorte der Personen verwenden",
usePositionsHint: "Jede Person entscheidet selbst, ob sie ihren Standort teilt, und nur solange die App geöffnet ist. Nur Inhaber und Admins sehen ihn, um Verspätungen zu erkennen. Nur der letzte Standort wird gespeichert, zwei Stunden lang.",
clearDepot: "Entfernen",
lessA11y: "Weniger: {{label}}",
moreA11y: "Mehr: {{label}}",
timeOff: "Abwesenheit am {{day}}",
removeOffA11y: "Abwesenheit von {{name}} entfernen",
off: {
allDay: "Ganzer Tag",
morning: "Vormittag",
afternoon: "Nachmittag",
},
},
parts: {
title: "Benötigte Teile",
empty: "Keine Teile aufgeführt. Fügen Sie hinzu, was mitgebracht werden muss.",
addLabel: "Teil oder Material",
add: "Teil hinzufügen",
removeA11y: "{{part}} entfernen",
failed: "Das Teil konnte nicht gespeichert werden. {{message}}",
availability: {
unknown: "Nicht bestätigt",
available: "Verfügbar",
reserved: "Reserviert",
unavailable: "Nicht verfügbar",
},
heldAt: "Lagert bei {{site}}",
notHeld: "Wo lagert es?",
clearHeld: "Entfernen",
},
jobPlanning: {
title: "Planung",
people: "Personen gleichzeitig",
fewerA11y: "Weniger Personen",
moreA11y: "Mehr Personen",
appointment: "Muss stattfinden zwischen",
on: "Am",
from: "Von",
to: "Bis",
saveAppointment: "Zeitfenster speichern",
clearAppointment: "Zeitfenster entfernen",
window: "{{on}}, {{from}}–{{to}}",
noWindow: "Jederzeit",
waitsOn: "Wartet auf",
waitsOnNone: "Nichts",
removeDepA11y: "Wartet nicht mehr auf {{title}}",
addDepA11y: "Auf {{title}} warten",
failed: "Speichern nicht möglich. {{message}}",
},
refine: {
planningTitle: "Planung",
partsTitle: "Teile",
planning: {
planned: "Geplant",
unplanned: "Ungeplant",
blocked: "Blockiert",
},
parts: {
ready: "Bereit",
unavailable: "Nicht verfügbar",
unknown: "Nicht bestätigt",
},
},
lanes: {
a11y: "Spalten zeigen",
people: "Nach Person",
site: "Nach Standort",
asset: "Nach Anlage",
noSite: "Kein Standort",
noAsset: "Keine Anlage",
},
review: {
overrun: "{{title}} dauert {{duration}} länger. Der restliche Tag von {{name}} passt nicht mehr.",
absence_one: "{{name}} fehlt bei {{count}} geplantem Einsatz.",
absence_other: "{{name}} fehlt bei {{count}} geplanten Einsätzen.",
urgent_one: "{{count}} dringender Auftrag ist nicht geplant.",
urgent_other: "{{count}} dringende Aufträge sind nicht geplant.",
part_unavailable: "Ein Teil für {{title}} ist nicht mehr verfügbar.",
cancelled: "{{title}} wurde abgesagt: die Zeit ist frei.",
early_finish: "{{name}} hat {{title}} früher beendet: es ist Zeit für mehr.",
running_late: "{{name}} kommt vom aktuellen Standort aus etwa {{duration}} zu spät zu {{title}}.",
more: "+{{count}} weitere",
action: "Plan prüfen",
dismissA11y: "Zurückstellen",
nothing: "Hier lässt sich nichts verschieben. Das muss von Hand entschieden werden.",
},
position: {
  stop: "Teilen beenden",
  share: "Standort teilen",
sharingShort: "Standort wird geteilt",
stopA11y: "Standort nicht mehr teilen",
offer: "Teilen Sie Ihren Standort während der Arbeit, damit Ihr Tag angepasst werden kann, wenn Sie sich verspäten.",
explainTitle: "Standort teilen?",
explain: "Solange diese App geöffnet ist und Sie heute Arbeit haben, wird Ihr Standort alle paar Minuten gesendet. Nur die Inhaber und Admins Ihres Arbeitsbereichs sehen ihn, um zu erkennen, wann Sie sich beim nächsten Termin verspäten. Nur der letzte Standort wird gespeichert, er wird nach zwei Stunden gelöscht, und Sie können jederzeit aufhören.",
explainConfirm: "Teilen, solange die App geöffnet ist",
explainCancel: "Nicht jetzt",
denied: "Die Standortfreigabe ist für diese App aus. Erlauben Sie sie in den Geräteeinstellungen, um Ihren Standort zu teilen.",
failed: "Die Freigabe konnte nicht geändert werden. {{message}}",
fromYou: "Etwa {{duration}} von Ihnen bis {{title}}",
seen: "Vor {{duration}} gesehen",
seenNow: "Gerade eben gesehen",
},
slot: {
createA11y: "Arbeit um {{time}} anlegen",
clear: "Keine Überschneidung mit ihrem Tag",
},
rail: {
allDay: "Ganztägig",
forecast: "Prognose",
forecastA11y: "Prognose, noch nicht gebucht: {{title}}",
},
agenda: {
empty: "Für diesen Tag ist nichts geplant. Mit den Pfeilen wechseln Sie den Tag.",
},
error: {
  tryAgain: "Versuchen Sie es gleich noch einmal.",
  offline: "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  notAllowed: "Sie dürfen das nicht ändern.",
load: "Der Plan konnte nicht geladen werden.",
retry: "Erneut versuchen",
},
loadingA11y: "Plan wird geladen",
truncated: "An diesen Tagen gibt es mehr Arbeit, als der Kalender lädt. Grenzen Sie die Ansicht mit „Filtern“ ein.",
},
scheduler: {
  contractor: {
    giveNow: "An Auftragnehmer geben",
    pick: "Auftragnehmer auswählen",
    change: "{{name}} · Ändern",
    hint: "Sie erhalten es unter „Meine Arbeit“ und brauchen ein AssetWRX-Konto. Sie zeichnen es weiterhin ab.",
    missing: "Wählen Sie den Auftragnehmer für diese Inspektion.",
  },
  fitLine: {
    bestAvailable: "Beste verfügbare Wahl",
    goodFit: "Passt gut",
    line: "Beste Wahl: {{name}} · {{score}} % passend · {{why}}",
  },
  fitReason: {
    certification: "Hat eine erforderliche Zertifizierung",
    withinRange: "In erreichbarer Entfernung",
    closeToSite: "Nahe am Standort",
    available: "Als verfügbar markiert",
    team: "Im zuständigen Team",
    capacity: "Hat freie Zeit",
    lightlyBooked: "Nur {{n}} Std. eingeplant",
    nothingBooked: "Nichts eingeplant",
    onTime: "Wird meist pünktlich fertig",
    verifiedHistory: "Die Arbeit wird meist bestätigt",
    assetTypeExperience: "Erfahrung mit diesem Anlagentyp",
    priorWorkOnAsset: "Hat schon an dieser Anlage gearbeitet",
    skillsMatch: "Hat die nötigen Fähigkeiten",
    categoryMany: "{{n}} abgeschlossene Aufträge in dieser Kategorie",
    categoryOne: "1 abgeschlossener Auftrag in dieser Kategorie",
  },
  blocker: {
    not_assignable: "Kann keine Arbeit zugewiesen bekommen",
    inactive_contractor: "Auftragnehmer ist nicht aktiv",
    no_site_access: "Kein Zugang zu diesem Standort",
    unavailable: "Zu dieser Zeit nicht verfügbar",
    missing_certification: "Eine erforderliche Zertifizierung fehlt",
    missing_mandatory_skill: "Eine erforderliche Fähigkeit fehlt",
  },
  slotReason: {
    afterDue: "Nach dem Fälligkeitsdatum",
    sameSite: "Gleicher Standort wie der Auftrag davor",
    beforeDue: "Vor dem Fälligkeitsdatum",
    minutes: "{{n}} Min.",
    hours: "{{n}} Std.",
    gapFree: "Freie Lücke von {{duration}}",
    firstGap: "Erste freie Lücke von {{duration}}",
  },
  notes: {
    revert: "Zurücksetzen",
    discard: "Verwerfen",
    accept: "Übernehmen",
    tidyFailedTitle: "Die Notiz konnte nicht überarbeitet werden",
    tidiedReview: "Prüfen Sie sie und tippen Sie dann auf Übernehmen.",
    tidiedTitle: "Überarbeitete Notiz",
    tidyUp: "Mit KI überarbeiten",
    stop: "Stopp",
    dictate: "Diktieren",
  },
  assignee: {
    noMatch: "Niemand in Ihrem Team passt.",
    search: "Ihr Team durchsuchen",
    blocked: "nicht verfügbar",
    contractor: "Auftragnehmer",
    technician: "Techniker",
    notEligibleItem: "{{name}} ({{reason}})",
    notEligible: "Kann das nicht übernehmen: {{list}}",
    bestMatch: "Beste Wahl: {{name}}",
    assignA11y: "{{name}} zuweisen",
    recommended: "Empfohlen: {{name}}",
    youSuffix: "{{name}} (Sie)",
    you: "Sie",
  },
  invite: {
    description: "Checkliste: {{checklist}}",
    title: "Inspektion: {{asset}}",
  },
  errors: {
    photosOtherWorkspace: "Ihre Fotos bleiben im Arbeitsbereich, in dem Sie diesen Auftrag erstellt haben. Wechseln Sie dorthin zurück und tippen Sie auf Speichern abschließen.",
    otherWorkspace: "Wechseln Sie zurück in den Arbeitsbereich, in dem Sie diesen Auftrag erstellt haben, und tippen Sie auf Speichern abschließen.",
    pickTime: "Wählen Sie ein Datum und eine Uhrzeit und versuchen Sie es erneut.",
  },
  errorTitles: {
    reschedule: "Neue Zeit nicht gespeichert",
    jobLater: "Auftrag nicht geplant",
    jobNow: "Auftrag nicht erstellt",
    inspectionLater: "Inspektion nicht geplant",
    inspectionNow: "Inspektion nicht gestartet",
  },
  checklist: {
    noMatch: "Keine Checkliste passt. Versuchen Sie ein anderes Wort oder tippen Sie auf Neue Checkliste.",
    search: "Checklisten suchen",
    add: "Hinzufügen",
    done: "Fertig",
    change: "Ändern",
    picked: "Sie haben diese ausgewählt.",
    loadFailed: "Ihre Checklisten wurden nicht geladen.",
    loading: "Checklisten werden geladen…",
  },
  slotAfterDue: "nach dem Fälligkeitsdatum",
  moreSummaryShort: "Ablauf und Erinnerungen",
  renewing: "{{title}} wird erneuert. Diese Inspektion hält die Nachweise für die Erneuerung fest.",
  renewingJob: "{{title}} wird erneuert. Wenn dieser Arbeitsauftrag erledigt ist, erstellen Sie daraus das Ersatzzertifikat.",
  renewJobTitle: "{{title}} erneuern",
  fromRequest: "Aus der Anfrage: {{title}}",
  runMode: {
    list: "Liste",
    guided_group: "Nach Abschnitt",
    guided_item: "Schritt für Schritt",
  },
  reminder: {
    "2day": "2 Tage vorher",
    "1day": "1 Tag vorher",
    "2hr": "2 Stunden vorher",
    "1hr": "1 Stunde vorher",
    "30min": "30 Minuten vorher",
    "15min": "15 Minuten vorher",
    at_time: "Zur geplanten Zeit",
  },
  cta: {
    scheduleJob: "Auftrag planen",
    scheduleInspection: "Inspektion planen",
    createJob: "Auftrag erstellen",
    startInspection: "Inspektion starten",
    saveTime: "Neue Zeit speichern",
    finishJob: "Speichern abschließen",
  },
  heading: {
    job: "Auftrag · {{asset}}",
    inspection: "Inspektion · {{asset}}",
    rescheduleJob: "Auftrag verschieben",
    rescheduleInspection: "Inspektion verschieben",
  },
  done: {
    jobCreated: "Auftrag für {{asset}} erstellt.",
    jobScheduled: "Auftrag für {{asset}} am {{when}} geplant.",
    jobCreatedPhotos: "Auftrag erstellt. Fotos auf diesem Gerät zum Hochladen gespeichert.",
    jobRescheduled: "Auftrag für {{asset}} auf {{when}} verschoben.",
    open: "Öffnen",
    inspectionRepeats: "Inspektion für {{asset}} am {{when}} geplant. Wiederholung: {{how}}.",
    inspectionScheduled: "Inspektion für {{asset}} am {{when}} geplant. Sie erscheint an diesem Tag unter Arbeit.",
    inspectionRescheduled: "Inspektion für {{asset}} auf {{when}} verschoben.",
  },
  hide: "Ausblenden",
  moreSummary: "Ausführung, Erinnerungen, Notizen und wer es erledigt",
  errorBody: "Es wurde nichts gespeichert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  errorPartialTitle: "Auftrag erstellt; Speichern unvollständig",
  repeat: {
    advance: {
      on_calendar: "An den geplanten Terminen",
      on_completion: "Nach Erledigung dieses Termins",
    },
    nextFrom: "Wann ist der nächste fällig?",
    noLimit: "Kein Limit",
    maxTimes: "Beenden nach (Mal)",
    use: "{{how}} verwenden",
    suggested: "Vorschlag: {{how}}. {{why}}",
    planHint: "Um nach Zählerstand oder an festen Terminen zu wiederholen, fügen Sie stattdessen an der Anlage einen Wartungsplan hinzu.",
    errorMax: "Geben Sie an, wie oft, oder lassen Sie das Feld leer.",
    errorEndBeforeStart: "Die Wiederholung kann nicht vor dem ersten Termin enden.",
    errorEnd: "Wählen Sie den Tag, an dem die Wiederholung endet.",
  },
show: "Anzeigen",
},
workItemCopy: {
issues_one: "{{count}} Problem",
issues_other: "{{count}} Probleme",
inspectionFallback: "Inspektion",
},
assistantCards: {
draftFindingPhoto: "Befund aus dem Foto entwerfen",
suggestTriagePriority: "Triage-Priorität vorschlagen",
recurringRaisesPriority: "Ein wiederkehrendes Problem würde die Priorität erhöhen.",
suggestRepair_one: "Reparatur für {{count}} nicht bestandenen Punkt vorschlagen",
suggestRepair_other: "Reparatur für {{count}} nicht bestandene Punkte vorschlagen",
checkExistingRepair: "Prüfen Sie zuerst die vorhandene Reparatur — es könnte ein Duplikat sein.",
draftFindingEvidence: "Befund aus den Nachweisen entwerfen",
suggestPriority: "Priorität vorschlagen",
suggestContractor: "Am besten passenden Auftragnehmer vorschlagen",
contractorRecurring: "Ein Auftragnehmer erledigt immer wieder Arbeiten an dieser Anlage.",
verifyEvidence: "Abschlussnachweise verifizieren",
suggestFollowUp: "Folgemaßnahme vorschlagen",
verifyBeforeSignOff: "Abschlussnachweise vor der Abnahme verifizieren",
summariseJourney: "Journey für den Bericht zusammenfassen",
summarisePortfolio: "Portfolio-Journey zusammenfassen",
portfolioRisk: "Portfoliorisiko {{band}} ({{score}}/100)",
riskBandLow: "niedrig",
riskBandMedium: "mittel",
riskBandHigh: "hoch",
},
evidenceLocal: {
identifierVin: "VIN {{value}}",
identifierSerial: "Seriennummer {{value}}",
identifierOther: "Kennung {{value}}",
codes_one: "{{count}} Code",
codes_other: "{{count}} Codes",
readings_one: "{{count}} Messwert",
readings_other: "{{count}} Messwerte",
complianceLabel: "{{scheme}}-Kennzeichnung",
dates_one: "{{count}} Datum",
dates_other: "{{count}} Datumsangaben",
recognised: "{{label}} erkannt. Auf dem Gerät wurden keine strukturierten Daten gefunden.",
nothingFound: "Auf dem Gerät wurden keine Informationen ausgelesen.",
found: "Auf dem Gerät gefunden: {{parts}}.",
separator: ", ",
mobileOnly: "Die Analyse auf dem Gerät läuft in der mobilen App.",
failed: "Nachweise konnten auf dem Gerät nicht analysiert werden.",
},
fitRisks: {
missesDueDates: "Verpasst oft Fälligkeitsdaten",
repeatReopens: "Wiederholte Wiedereröffnungen bei jüngsten Arbeiten",
someRework: "Etwas Nacharbeit bei früheren Aufträgen",
hoursCommitted_one: "{{count}} Std. bereits verplant",
hoursCommitted_other: "{{count}} Std. bereits verplant",
heavyWorkload: "Hohe aktuelle Arbeitslast",
elevatedWorkload: "Erhöhte aktive Arbeitslast",
overdueAssignments_one: "{{count}} überfällige Zuweisung",
overdueAssignments_other: "{{count}} überfällige Zuweisungen",
},
journeySignals: {
whereAsset: "an dieser Anlage",
wherePortfolio: "im gesamten Portfolio",
alreadyRepairedLabel: "Eine Reparatur {{where}} wurde bereits abgeschlossen.",
alreadyRepairedDetailAgo_one: "Der letzte abgeschlossene Auftrag {{where}} wurde vor {{count}} T. geschlossen — prüfen Sie, ob es sich um ein Duplikat handelt, bevor Sie neue Arbeit anlegen.",
alreadyRepairedDetailAgo_other: "Der letzte abgeschlossene Auftrag {{where}} wurde vor {{count}} T. geschlossen — prüfen Sie, ob es sich um ein Duplikat handelt, bevor Sie neue Arbeit anlegen.",
alreadyRepairedDetail: "Es gibt bereits einen abgeschlossenen Auftrag {{where}} — prüfen Sie, ob es sich um ein Duplikat handelt, bevor Sie neue Arbeit anlegen.",
recurringLabel_one: "{{count}} separater Auftrag oder Befund {{where}} erfasst.",
recurringLabel_other: "{{count}} separate Aufträge oder Befunde {{where}} erfasst.",
recurringDetail_one: "{{count}} Arbeitseintrag {{where}} führte in den letzten {{days}} Tagen zu einem Auftrag oder Befund — bei einer Anlage mit wiederholter Wartung ist eine Ursachenanalyse womöglich sinnvoller als eine weitere Einzelreparatur.",
recurringDetail_other: "{{count}} Arbeitseinträge {{where}} führten in den letzten {{days}} Tagen zu einem Auftrag oder Befund — bei einer Anlage mit wiederholter Wartung ist eine Ursachenanalyse womöglich sinnvoller als eine weitere Einzelreparatur.",
contractorLabel_one: "{{name}} hat {{where}} {{count}} Auftrag erledigt.",
contractorLabel_other: "{{name}} hat {{where}} {{count}} Aufträge erledigt.",
contractorDetail: "Wiederholte Einsätze desselben Auftragnehmers können auf eine ungelöste Ursache hinweisen.",
healthLabel_one: "Die Gesundheit der Anlage verschlechtert sich (um {{count}} Punkt gesunken).",
healthLabel_other: "Die Gesundheit der Anlage verschlechtert sich (um {{count}} Punkte gesunken).",
healthDetail: "Der Betriebszustand fiel von {{then}} auf {{now}} — priorisieren Sie diese Anlage, bevor sie den Status „Handlungsbedarf“ erreicht.",
overdueLabel_one: "{{count}} offene Folgemaßnahme {{where}} ist überfällig.",
overdueLabel_other: "{{count}} offene Folgemaßnahmen {{where}} sind überfällig.",
overdueDetail: "Offene Journeys {{where}} haben mindestens ein Phasen-SLA überschritten — sie drohen weiter in Verzug zu geraten.",
},
suggestJobCopy: {
noInspectionData: "Keine Inspektionsdaten vorhanden, um Aufträge vorzuschlagen.",
noSuggestions: "Keine Auftragsvorschläge für diese Inspektion.",
suggestionsReady_one: "{{count}} Auftragsvorschlag bereit.",
suggestionsReady_other: "{{count}} Auftragsvorschläge bereit.",
addRequestSummary: "Fügen Sie eine Zusammenfassung der Anfrage hinzu, um einen Auftrag vorzuschlagen.",
derivedFromRequest: "Auftragsvorschlag aus der Anfrage abgeleitet.",
derivedWarning: "Aus der Anfrage abgeleitet (ohne KI). Bestätigen Sie den Vorschlag, bevor Sie den Auftrag erstellen.",
enableAi: "Aktivieren Sie die KI, um einen Folgeauftrag vorzuschlagen.",
enableAiHint: "Lassen Sie die KI einen Folgeauftrag vorschlagen.",
offline: "KI-Vorschlag offline nicht verfügbar.",
offlineWarning: "KI-Vorschlag offline nicht verfügbar",
followUpFailed: "Es konnte kein Folgeauftrag vorgeschlagen werden.",
notAvailable: "Auftragsvorschläge sind in diesem Kontext nicht verfügbar.",
suggestionFailed: "Vorschlag fehlgeschlagen",
jobFailed: "Es konnte kein Auftrag vorgeschlagen werden.",
},
rules: {
title: "Gruppenregeln",
subtitle: "Eine Checkliste für viele Anlagen wiederholen",
intro: "Eine Gruppenregel legt dieselbe Checkliste auf jede passende Anlage, etwa jede Brandschutztür in Gebäude A jeden Monat. Neue passende Anlagen kommen von selbst dazu.",
howTitle: "So funktionieren Gruppenregeln",
howStep1: "Wählen Sie die Gruppe: eine Anlagenart, einen Ihrer Anlagentypen, eine Ortsart oder eine Zone. Sie können sie auf das beschränken, was in einem Ort liegt.",
howStep2: "Wählen Sie die Checkliste, wie oft, und das Datum der ersten Prüfung.",
howStep3: "Beim Speichern entsteht für jede Anlage der Gruppe eine Prüfung. Eine Anlage, die später dazukommt, bekommt ihre eigene; bei einer, die die Gruppe verlässt, wird die noch nicht begonnene Prüfung abgesagt.",
howExample: "Beispiel: „Monatliche Brandschutztür-Prüfung“ nimmt jede Brandschutztür in Gebäude A. Beim Speichern entstehen 24 Prüfungen zum ersten Datum. Auf der Seite Arbeit erscheinen sie als eine Zeile.",
howEdits: "Wenn Sie eine Regel bearbeiten, ändern sich ihre noch nicht begonnenen Prüfungen. Begonnene und erledigte Prüfungen ändern sich nie. Wenn Sie eine Regel stoppen, werden die nicht begonnenen abgesagt.",
howTour: "Zeig es mir",
howGuide: "Anleitung lesen",
add: "Gruppenregel hinzufügen",
newTitle: "Neue Gruppenregel",
editTitle: "Gruppenregel bearbeiten",
nameLabel: "Name",
namePlaceholder: "Monatliche Brandschutztür-Prüfung",
nameRequired: "Geben Sie der Regel einen Namen",
whatLabel: "Welche Anlagen",
whatHint: "Wählen Sie zuerst eine Anlagenart.",
anyPlace: "Jeder Ort",
whereLabel: "Wo",
whereHint: "In einem Ort heißt alles darin, in jeder Tiefe: die Etagen eines Gebäudes, ihre Räume und was darin verbaut ist.",
anywhere: "Überall",
aPlace: "ein Ort",
someType: "Ein Anlagentyp",
anyAsset: "Jede Anlage",
inZone: "in Zone {{zone}}",
insidePlace: "in {{place}}",
assignedTo: "an {{name}}",
zoneLabel: "Zone (optional)",
zoneHint: "Nur Anlagen mit dieser Zone.",
checklistLabel: "Checkliste",
pickChecklist: "Checkliste wählen",
checklistRequired: "Wählen Sie eine Checkliste",
searchChecklists: "Checklisten suchen",
howOftenLabel: "Wie oft",
startsOnLabel: "Erste Prüfung am",
startsOnInvalid: "Datum als JJJJ-MM-TT eingeben",
assigneeLabel: "Zuweisen an (optional)",
assigneeHint: "Die Person wird einmal benachrichtigt, egal wie viele Prüfungen die Regel anlegt.",
nobody: "Noch niemand",
someone: "Jemand",
you: "{{name}} (Sie)",
searchPeople: "Personen suchen",
needsGroup: "Wählen Sie eine Anlagenart, einen Anlagentyp, eine Ortsart oder eine Zone.",
sentence: "{{recurrence}} ab {{date}}: jede {{what}}{{where}} bekommt die Checkliste „{{checklist}}“.",
sentenceNoChecklist: "{{recurrence}} ab {{date}}: jede {{what}}{{where}}. Wählen Sie noch eine Checkliste.",
sentenceNeedsGroup: "Geben Sie an, welche Anlagen, dann steht die Regel hier.",
sentenceInside: " in {{place}}",
sentenceInZone: " in Zone {{zone}}",
sentenceAssigned: "Zugewiesen an {{name}}.",
counting: "Wird gezählt…",
estimate_one: "Sie umfasst gerade {{count}} Anlage.",
estimate_other: "Sie umfasst gerade {{count}} Anlagen.",
estimateHint: "Eine Anlage, die später zur Gruppe kommt, bekommt ihre eigene Prüfung, fällig am Tag, an dem sie dazukommt.",
estimateOffline: "Gezählt aus den Anlagen auf diesem Gerät, weil der Server nicht erreichbar war. Die Regel gilt trotzdem für jeden Treffer.",
editUpdates_one: "Beim Speichern ändert sich {{count}} noch nicht begonnene Prüfung.",
editUpdates_other: "Beim Speichern ändern sich {{count}} noch nicht begonnene Prüfungen.",
editLeaving_one: "{{count}} Prüfung wird abgesagt: Ihre Anlage gehört nicht mehr zur Gruppe.",
editLeaving_other: "{{count}} Prüfungen werden abgesagt: Ihre Anlagen gehören nicht mehr zur Gruppe.",
editJoining_one: "{{count}} neue Prüfung wird angelegt.",
editJoining_other: "{{count}} neue Prüfungen werden angelegt.",
editKept: "Begonnene und erledigte Prüfungen ändern sich nicht.",
cancel: "Abbrechen",
save: "Regel speichern",
saved_one: "Gespeichert. {{count}} Prüfung ist geplant.",
saved_other: "Gespeichert. {{count}} Prüfungen sind geplant.",
failedTitle: "Regel konnte nicht gespeichert werden",
failedBody: "Prüfen Sie die Verbindung und versuchen Sie es erneut.",
active: "Aktiv",
stopped: "Gestoppt",
savedMoreComing_one: "Gespeichert. Bisher ist {{count}} Prüfung geplant; die übrigen werden in den nächsten Minuten ergänzt oder geändert.",
savedMoreComing_other: "Gespeichert. Bisher sind {{count}} Prüfungen geplant; die übrigen werden in den nächsten Minuten ergänzt oder geändert.",
moreComing: "Prüfungen werden noch ergänzt oder geändert. Schauen Sie in ein paar Minuten wieder vorbei.",
openVisits_one: "{{count}} offene Prüfung",
openVisits_other: "{{count}} offene Prüfungen",
fromRuleLabel: "Aus Gruppenregel",
edit: "Bearbeiten",
stop: "Stoppen",
restart: "Neu starten",
stopConfirmTitle: "Diese Regel stoppen?",
stopConfirmBody_one: "Ihre {{count}} noch nicht begonnene Prüfung wird abgesagt. Erledigte Prüfungen bleiben.",
stopConfirmBody_other: "Ihre {{count}} noch nicht begonnenen Prüfungen werden abgesagt. Erledigte Prüfungen bleiben.",
emptyTitle: "Noch keine Gruppenregeln",
emptyBody: "Ein Inhaber oder Admin richtet sie ein. Ihre Prüfungen erscheinen dann auf der Seite Arbeit wie jede andere.",
emptyBodyAdmin: "Fügen Sie Ihre erste Regel hinzu, um eine ganze Gruppe von Anlagen nach einem Zeitplan zu prüfen.",
foldedRow_one: "{{name}} · {{count}} Anlage",
foldedRow_other: "{{name}} · {{count}} Anlagen",
},
rounds: {
title: "Rundgang starten",
intro: "Ein Auftrag, der die Orte und Objekte in {{place}} abläuft. Jeder Halt bekommt seine eigene Checkliste.",
stopsLabel: "Halte",
stopCount_one: "{{count}} Halt",
stopCount_other: "{{count}} Halte",
all: "Alle",
none: "Keine",
loading: "Inhalt wird gelesen…",
tooMany: "Ein Rundgang hat höchstens {{max}} Halte. Entfernen Sie einige.",
titleLabel: "Name des Rundgangs",
defaultTitle: "Rundgang {{checklist}}: {{place}}",
dateLabel: "Datum (optional)",
dateHint: "JJJJ-MM-TT. Leer lassen, um ihn später zu planen.",
description_one: "Rundgang mit {{count}} Halt in {{place}}.",
description_other: "Rundgang mit {{count}} Halten in {{place}}.",
create_one: "Rundgang mit {{count}} Halt starten",
create_other: "Rundgang mit {{count}} Halten starten",
created_one: "Rundgang mit {{count}} Halt gestartet",
created_other: "Rundgang mit {{count}} Halten gestartet",
failedTitle: "Rundgang konnte nicht gestartet werden",
failedBody: "Es wurde nichts angelegt. Prüfen Sie die Verbindung und versuchen Sie es erneut.",
emptyTitle: "Hier gibt es nichts zu besuchen",
emptyBody: "Fügen Sie zuerst Orte oder Geräte in diesem Ort hinzu oder ändern Sie die Filter.",
},
};
